/*
  MIT License

  Copyright (c) 2022 Open Source  UOM

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in all
  copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.

*/

import {Service} from "../global/types";

export const servicesData: Array<Service> = [

    // Υγεία

    {
        title: "Υπουργείο Υγείας",
        url: "https://www.moh.gov.gr/",
        category: "ΥγειοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://www.moh.gov.gr/style/favicon/android-icon-192x192.png",
        description:`
                        Το Υπουργείο Υγείας καθορίζει την εθνική πολιτική υγείας στην Ελλάδα. Επιβλέπει το Εθνικό Σύστημα Υγείας (ΕΣΥ) και τη λειτουργία νοσοκομείων και κέντρων υγείας. Ενισχύει προγράμματα πρόληψης, εμβολιασμών και δημόσιας υγείας. Διαχειρίζεται την Εθνική Κεντρική Αρχή Προμηθειών Υγείας (ΕΚΑΠΥ) για φάρμακα και υλικά.
                    `,
    },
    {
        title: "Σύστημα Πρωτοβάθμιας Φροντίδας Υγείας",
        url: "https://ehealth.gov.gr/p-rv/p/",
        category: "ΥγειοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://ehealth.gov.gr/p-rv/VAADIN/themes/eRV/favicon.ico",
        description:`
                        Η πλατφόρμα αποτελεί επίσημη υπηρεσία του Υπουργείου Υγείας για την εγγραφή στον Προσωπικό Γιατρό και τη διαχείριση ιατρικών ραντεβού. Οι πολίτες εγγράφονται χρησιμοποιώντας κωδικούς TaxisNet και ΑΜΚΑ. Παρέχει επίσης δυνατότητες άυλης συνταγογράφησης και πρόσβασης στον Ατομικό Ηλεκτρονικό Φάκελο Υγείας.
                    `,
    },
    {
        title: "Υγεία Πολιτών",
        url: "https://www.moh.gov.gr/articles/citizen/",
        category: "ΥγειοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://www.moh.gov.gr/style/favicon/android-icon-192x192.png",
        description:`
                        Τμήμα της επίσημης ιστοσελίδας του Υπουργείου Υγείας. Περιλαμβάνει πληροφορίες για τον πολίτη, για τα προγράμματα υγείας, τις υπηρεσίες υγείας, τους εμβολιασμούς καθώς και πληροφορίες που αφορούν επαγγελματίες υγείας και δημόσιες δομές. Περιλαμβάνει επίσης προγράμματα εφημεριών των νοσοκομείων και φαρμακείων ενώ παρέχει πρόσβαση σε στατιστικά στοιχεία και χρήσιμους συνδέσμους.
                    `,
    },
    {
        title: "MyHealth",
        url: "https://myhealth.gov.gr/",
        category: "ΥγειοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://myhealth.gov.gr/favicon.ico",
        description:`
                        Αποτελεί τον Εθνικό Ηλεκτρονικό Φάκελο Υγείας (ΕΗΦΥ) της Ελλάδας, προσφέροντας στους πολίτες άμεση πρόσβαση στο πλήρες ιατρικό τους ιστορικό. Οι πολίτες μπορούν να δουν διαγνώσεις, συνταγές, παραπεμπτικά, αποτελέσματα εξετάσεων, εμβολιασμούς και βεβαιώσεις νοσηλείας. Η πλατφόρμα διευκολύνει την επικοινωνία με τους ιατρούς, ενώ είναι προσβάσιμη και μέσω κινητών συσκευών.
                    `,
    },
    {
        title: "Ενημέρωση Πολιτών",
        url: "https://eody.gov.gr/",
        category: "ΥγειοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://eody.gov.gr/wp-content/themes/egritosTpl/images/favicon.png",
        description:`
                        Ο ιστότοπος του Εθνικού Οργανισμού Δημόσιας Υγείας παρέχει αξιόπιστες πληροφορίες για τη δημόσια υγεία στην Ελλάδα. Προσφέρει ενημερώσεις για εμβολιασμούς, επιστημονικά τεκμηριωμένα επιδημιολογικά δεδομένα και κατευθυντήριες οδηγίες για την πρόληψη ασθενειών. Υποστηρίζει εκστρατείες ευαισθητοποίησης και παρέχει πληροφορίες για κρίσεις υγείας.
                    `,
    },
    {
        title: "Ηλεκτρονική Διακυβέρνηση Κοινωνικής Ασφάλισης (ΗΔΙΚΑ)",
        url: "https://www.idika.gr/",
        category: "ΥγειοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://www.idika.gr/wp-content/uploads/2023/11/cropped-idika-fav-32x32.jpg",
        description:`
                        Η ΗΔΙΚΑ προσφέρει ηλεκτρονικές υπηρεσίες για την υγεία και την κοινωνική ασφάλιση. Οι πολίτες μπορούν να χρησιμοποιούν την άυλη συνταγογράφηση, να βλέπουν τον ηλεκτρονικό τους φάκελο υγείας και να κλείνουν e ραντεβού με γιατρούς. Παρέχεται ενημέρωση για την εγγραφή στον προσωπικό γιατρό, καθώς και πρόσβαση σε στοιχεία για παροχές από τον ΕΦΚΑ και τον ΟΠΕΚΑ.
                    `,
    },
    {
        title: "Αριθμός Μητρώου Κοινωνικής Ασφάλισης (ΑΜΚΑ)",
        url: "https://www.amka.gr/",
        category: "ΥγειοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://myhealth.gov.gr/favicon.ico",
        description:`
                        Ο Αριθμός Μητρώου Κοινωνικής Ασφάλισης (ΑΜΚΑ) αποτελεί την ηλεκτρονική πλατφόρμα της Η.ΔΙ.Κ.Α. Παρέχει στους πολίτες τη δυνατότητα αναζήτησης και επαλήθευσης του αριθμού μητρώου κοινωνικής ασφάλισης, ο οποίος είναι απαραίτητος για την πρόσβαση σε υπηρεσίες υγείας και κοινωνικής ασφάλισης. Η υπηρεσία διαθέτει επίσης ειδική λειτουργία μαζικής αναζήτησης για εργοδότες, επιτρέποντάς τους να επαληθεύουν τα στοιχεία των εργαζομένων τους για ασφαλιστικούς σκοπούς.
                    `,
    },
    {
        title: "Ηλεκτρονικές διασυνοριακές υπηρεσίες υγείας",
        url: "https://www.ncpehealth.gr/citizens.html",
        category: "ΥγειοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://www.ncpehealth.gr/images/favicon.png",
        description:`
                        Η ιστοσελίδα αποτελεί μέρος του Εθνικού Σημείου Επαφής για την Υγεία και παρέχει πληροφορίες για πολίτες σχετικά με τη διασυνοριακή υγειονομική περίθαλψη στην ΕΕ. Εξηγεί τα δικαιώματα πρόσβασης σε υπηρεσίες υγείας σε άλλες χώρες μέλη μέσω του MyHealth@EU. Προσφέρει οδηγίες για αποζημιώσεις, συνταγές και ιατρική κάλυψη στο εξωτερικό.
                    `,
    },

    {
        title: "Ευρωπαϊκός Οργανισμός Φαρμάκων",
        url: "https://www.ema.europa.eu/en/homepage/",
        category: "ΥγειοΕυρωπαϊκοί Οργανισμοί",
        imgUrl: "https://www.ema.europa.eu/themes/custom/ema_theme/favicon.ico",
        description:`
                        Ο ιστότοπος του Ευρωπαϊκού Οργανισμού Φαρμάκων παρέχει πληροφορίες για την ασφάλεια και την έγκριση φαρμάκων και εμβολίων στην ΕΕ. Προσφέρει επιστημονικά τεκμηριωμένα δεδομένα για κλινικές δοκιμές, κανονισμούς και παρακολούθηση φαρμακευτικών προϊόντων. Υποστηρίζει τη δημόσια υγεία με διαφανείς διαδικασίες και πόρους για επαγγελματίες και πολίτες. Περιλαμβάνει ενημερώσεις για εμβόλια και θεραπείες, όπως για την COVID-19.
                    `,
    },

    {
        title: "Παγκόσμιος Οργανισμός Υγείας",
        url: "https://www.who.int/",
        category: "ΥγειοΔιεθνείς Οργανισμοί",
        imgUrl: "https://www.who.int/favicon.ico",
        description:`
                        Η επίσημη πύλη του ΠΟΥ (Παγκόσμιου Οργανισμού Υγείας). Παρέχει αξιόπιστες πληροφορίες για τη δημόσια υγεία παγκοσμίως. Προσφέρει επιστημονικά τεκμηριωμένα δεδομένα για εμβόλια, πρόληψη ασθενειών και πολιτικές υγείας. Υποστηρίζει το δικαίωμα στην υγεία μέσω κατευθυντήριων οδηγιών και προγραμμάτων. Είναι διαθέσιμος σε αρκετές γλώσσες για παγκόσμια πρόσβαση.
                    `,
    },

    {
        title: "Ένωση Ασθενών Ελλάδας",
        url: "https://greekpatient.gr/",
        category: "ΥγειοΜη Κυβερνητικοί Οργανισμοί",
        imgUrl: "https://greekpatient.gr/wp-content/uploads/2024/02/cropped-favicon-192x192.png",
        description:`
                        Η επίσημη πλατφόρμα της Ένωσης Ασθενών Ελλάδας, η οποία ιδρύθηκε με στόχο την προάσπιση των δικαιωμάτων των ασθενών. Αποτελεί επίσημο συνομιλητή της Πολιτείας και προωθεί την ενεργή συμμετοχή των ασθενών στη χάραξη πολιτικών υγείας και την πρόσβαση σε ποιοτικές υπηρεσίες. Παρέχει πληροφορίες για εκδηλώσεις, εκπαιδευτικά προγράμματα και θέσεις της Ένωσης.
                    `,
    },

    //Νόμοι

    {
        title: "Υπουργείο Δικαιοσύνης",
        url: "https://ministryofjustice.gr/",
        category: "ΝομοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://t0.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://ministryofjustice.gr&size=16",
        description:`
                        Το Υπουργείο Δικαιοσύνης εργάζεται για τη νομοθετική μεταρρύθμιση και την απονομή δικαιοσύνης στην Ελλάδα. Διαχειρίζεται το Εθνικό Ποινικό Μητρώο, διάφορες ψηφιακές υπηρεσίες και επιβλέπει τα δικαστήρια και τη νομική βοήθεια.
                    `,
    },
    {
        title: "Διαύγεια",
        url: "https://diavgeia.gov.gr/",
        category: "ΝομοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://diavgeia.gov.gr/&size=128",
        description:`
                        Η Διαύγεια είναι η επίσημη κυβερνητική πύλη για την ανάρτηση δημόσιων πράξεων. Το σύστημα αποτελεί βασικό εργαλείο διαφάνειας του δημόσιου τομέα, επιτρέποντας στους πολίτες την πρόσβαση σε δημόσιες πράξεις και αποφάσεις.
                    `,
    },
    {
        title: "Ελληνικό Κοινοβούλιο: Νομοθεσία και Δράση",
        url: "https://www.hellenicparliament.gr/el/",
        category: "ΝομοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://www.hellenicparliament.gr/favicon-32x32.png",
        description:`
                        Αποτελεί την επίσημη ιστοσελίδα της Βουλής των Ελλήνων. Περιλαμβάνει λεπτομέρειες για τη νομοθετική διαδικασία, το κοινοβουλευτικό έργο, τις επιτροπές, τα πρακτικά συνεδριάσεων καθώς και πρόσφατες ειδήσεις κοινοβουλευτικού ενδιαφέροντος (π.χ. νομοθετικές εξελίξεις και διεθνείς δραστηριότητες).
                        Επίσης, μέσα από την ενότητα των Εκδόσεων και της Ψηφιακής Βιβλιοθήκης, οι πολίτες έχουν πρόσβαση σε διάφορα κείμενα, όπως για παράδειγμα στο Σύνταγμα της Ελλάδος ή σε αποφάσεις της Βουλής.
                    `,
    },
    {
        title: "Ευρωπαϊκό Κοινοβούλιο: Οδηγός",
        url: "https://www.europarl.europa.eu/portal/el/",
        category: "ΝομοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://www.europarl.europa.eu/favicon.ico",
        description:`
                        Αποτελεί την επίσημη ιστοσελίδα του Ευρωπαϊκού Κοινοβουλίου και δίνει πληροφορίες σχετικά με το Κοινοβούλιο, τις Επιτροπές και Αντιπροσωπείες, τους Ευρωβουλευτές, την Επικαιρότητα και τις Εκλογές. Επίσης, δίνεται η δυνατότητα παρακολούθησης της δράσης του Κοινοβουλίου και επικοινωνίας με αυτό. Τέλος, συμπεριλαμβάνονται σύνδεσμοι για πρόσβαση σε ενημέρωση για ειδικά θέματα.
                    `,
    },
    {
        title: "Το επίσημο περιοδικό της Βουλής",
        url: "https://www.hellenicparliament.gr/Enimerosi/periodiko/",
        category: "ΝομοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://www.hellenicparliament.gr/favicon-32x32.png",
        description:`
                        Το «Επί του…περιστυλίου!» είναι το επίσημο ηλεκτρονικό περιοδικό της Βουλής των Ελλήνων, που αποτυπώνει το έργο και τις πρωτοβουλίες του Κοινοβουλίου με τρόπο άμεσο και προσβάσιμο. Καταγράφει νομοσχέδια και διεθνείς συμβάσεις που εγκρίθηκαν, προσφέροντας πλήρη πρόσβαση στα κείμενα των νόμων, τα πρακτικά των συνεδριάσεων και τα σχετικά βίντεο. Η πλατφόρμα ενισχύει τη διαφάνεια και διευκολύνει την πρόσβαση των πολιτών σε κυβερνητικά έγγραφα. Όλα τα τεύχη παραμένουν διαθέσιμα σε ψηφιακή μορφή.
                    `,
    },

    {
        title: "Πύλη ανοιχτών δεδομένων του Ευρωπαϊκού Κοινοβουλίου",
        url: "https://data.europarl.europa.eu/el/home/",
        category: "ΝομοΕυρωπαϊκοί Οργανισμοί",
        imgUrl: "https://data.europarl.europa.eu/assets/images/favicon-32x32.png",
        description:`
                        Στην Πύλη ανοικτών δεδομένων οι πολίτες μπορούν να αποκτήσουν πρόσβαση στο έργο του Κοινοβουλίου. Ο κατάλογος ενημερώνεται συνεχώς και παρέχει πρόσβαση, σχεδόν σε πραγματικό χρόνο, σε χιλιάδες έγγραφα και άλλο περιεχόμενο που παράγει το Ευρωπαϊκό Κοινοβούλιο καθημερινά.
                    `,
    },

    {
        title: "Εθνική Αρχή Διαφάνειας (ΕΑΔ)",
        url: "https://aead.gr/",
        category: "ΝομοΑνεξάρτητες Αρχές",
        imgUrl: "https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://aead.gr/&size=128",
        description:`
                        Η Εθνική Αρχή Διαφάνειας (ΕΑΔ) είναι η κύρια ανεξάρτητη αρχή κατά της διαφθοράς στην Ελλάδα, υπεύθυνη για τη διασφάλιση της νομιμότητας σε δημόσιες υπηρεσίες και φορείς. Πραγματοποιεί ελέγχους νομιμότητας, εκδίδει πόρισμα για δημόσιες συμβάσεις, δημοπρασίες και υπηρεσίες σε περιφέρειες και υπουργεία.
                    `,
    },
    {
        title: "Συνήγορος του Πολίτη",
        url: "https://www.synigoros.gr/el/",
        category: "ΝομοΑνεξάρτητες Αρχές",
        imgUrl: "https://www.synigoros.gr/favicon.ico",
        description:`
                        Ο Συνήγορος του Πολίτη ως ανεξάρτητη αρχή λειτουργεί ως θεματοφύλακας των δικαιωμάτων του πολίτη στον δημόσιο και ιδιωτικό τομέα. Ερευνά τα προβλήματα που προκαλούνται από νομοθετικές ή άλλες παρεμβάσεις της διοίκησης και αναλαμβάνει στοχευμένες πρωτοβουλίες αξιοποιώντας την τεχνογνωσία και τις και τις διευρυμένες αρμοδιότητες που διαθέτει.
                    `,
    },
    {
        title: "Ο Ευρωπαίος Διαμεσολαβητής",
        url: "https://www.ombudsman.europa.eu/el/publication/el/11134/",
        category: "ΝομοΑνεξάρτητες Αρχές",
        imgUrl: "https://www.ombudsman.europa.eu/favicon.ico",
        description:`
                        Ο Ευρωπαίος Διαμεσολαβητής είναι ένας ανεξάρτητος και αμερόληπτος θεσμός στον οποίο λογοδοτεί η διοίκηση της Ευρωπαϊκής Ένωσης. Διερευνά αναφορές για περιπτώσεις κακοδιοίκησης εκ μέρους των θεσμικών και λοιπών οργάνων και οργανισμών της ΕΕ. Όλοι οι πολίτες ή κάτοικοι της ΕΕ, οι επιχειρήσεις, οι ενώσεις ή άλλοι οργανισμοί που έχουν την καταστατική τους έδρα στην ΕΕ μπορούν να υποβάλουν αναφορά ακόμα και αν το κρούσμα κακοδιοίκησης δεν τους θίγει προσωπικά.
                    `,
    },
    {
        title: "Πώς να ακουστεί η φωνή σας στο Ευρωπαϊκό Κοινοβούλιο",
        url: "https://www.europarl.europa.eu/at-your-service/el/be-heard/",
        category: "ΝομοΑνεξάρτητες Αρχές",
        imgUrl: "https://data.europarl.europa.eu/assets/images/favicon-32x32.png",
        description:`
                        Το Ευρωπαϊκό Κοινοβούλιο προτρέπει τους πολίτες της ΕΕ να εκφράσουν την άποψή τους και να συμμετάσχουν στη λήψη αποφάσεων και στη διαμόρφωση ευρωπαϊκής πολιτικής.  Δίνονται πληροφορίες για τις ευρωπαϊκές εκλογές, την υποβολή καταγγελιών, την επικοινωνία με τον Ευρωπαίο Διαμεσολαβητή, την πρωτοβουλία πολιτών, και άλλες μεθόδους συμμετοχής. Διαθέσιμο και στα ελληνικά.
                    `,
    },

    {
        title: "ΣΥΝΤΑΓΜΑ WATCH.gr",
        url: "https://www.syntagmawatch.gr/",
        category: "ΝομοΙδρύματα - Οργανισμοί",
        imgUrl: "https://www.syntagmawatch.gr/wp-content/uploads/2019/05/favicon-01-300x300.png",
        description:`
                        Ο ιστότοπος προσφέρει ελεύθερη πρόσβαση σε πληροφορίες που αφορούν στο Σύνταγμα της Ελλάδος. Στόχος του είναι η ενημέρωση των πολιτών και η ενδυνάμωσή τους με γνώσεις σχετικές με τα συνταγματικά τους δικαιώματα, τους θεσμούς και τις συνταγματικές εξελίξεις. Προσφέρει αναλύσεις από ειδικούς επιστήμονες για διάφορα συνταγματικά ζητήματα καθώς και εκπαιδευτικό υλικό (σεμινάρια και σύντομα μαθήματα) ενώ ο πολίτης μπορεί να θέσει και τα δικά του ερωτήματα και να λάβει απαντήσεις.
                    `,
    },

    //Εκπαίδευση

    {
        title: "Υπουργείο Παιδείας, Θρησκευμάτων και Αθλητισμού",
        url: "https://www.minedu.gov.gr/",
        category: "ΕκπαιδοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://www.minedu.gov.gr/favicon.ico",
        description:`
                        Ο αρμόδιος κρατικός φορέας για την εκπαίδευση, τη θρησκευτική πολιτική και τον αθλητισμό. Η επίσημη ιστοσελίδα παρέχει πληροφορίες για το ελληνικό εκπαιδευτικό σύστημα, ανακοινώσεις, νομοθεσία, εξετάσεις, προγράμματα σπουδών και υπηρεσίες για μαθητές, φοιτητές, εκπαιδευτικούς και πολίτες. Επιπλέον, προσφέρει πρόσβαση σε ψηφιακές υπηρεσίες, όπως αιτήσεις, πιστοποιητικά και εγγραφές.
                    `,
    },
    {
        title: "Ινστιτούτο Εκπαιδευτικής Πολιτικής (ΙΕΠ)",
        url: "https://www.iep.edu.gr/",
        category: "ΕκπαιδοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://www.iep.edu.gr/images/favicon_IEP_Gr16X16.png",
        description:`
                        Επιτελικός, επιστημονικός και ερευνητικός φορέας που υποστηρίζει το Υπουργείο Παιδείας, Θρησκευμάτων και Αθλητισμού. Ασχολείται με θέματα που αφορούν την πρωτοβάθμια και δευτεροβάθμια εκπαίδευση, την επιμόρφωση των εκπαιδευτικών, τη μετάβαση από τη δευτεροβάθμια στην τριτοβάθμια εκπαίδευση, τη μεταλυκειακή εκπαίδευση, την αντιμετώπιση των εκπαιδευτικών ανισοτήτων, της μαθητικής διαρροής και της πρόωρης εγκατάλειψης του σχολείου, με στόχο τη διασφάλιση του δικαιώματος όλων των παιδιών στην εκπαίδευση.
                    `,
    },
    {
        title: "Εθνική Βιβλιοθήκη της Ελλάδος",
        url: "https://www.nlg.gr/",
        category: "ΕκπαιδοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://www.nlg.gr/wp-content/uploads/2018/02/cropped-EBE-transparet-100x100.png",
        description:`
                        Η Εθνική Βιβλιοθήκη της Ελλάδος λειτουργεί σήμερα σε τρεις σύγχρονες εγκαταστάσεις, με κύρια έδρα το ΚΠΙΣΝ. Διαθέτει πάνω από 1,1 εκατομμύριο έντυπα, 4500 χειρόγραφα, εφημερίδες, χάρτες και πολυμεσικά τεκμήρια, ιδιαίτερα πλούσια συλλογή σπάνιων εκδόσεων και αρχειακών τεκμηρίων. Προσφέρει ψηφιακές υπηρεσίες όπως τον ηλεκτρονικό κατάλογο, ψηφιακές συλλογές, συλλογή ιστοσελίδων και ηλεκτρονικό αναγνωστήριο, δωρεάν για όλους. Υποστηρίζει το Δίκτυο Ελληνικών Βιβλιοθηκών με 264+ περιφερειακές βιβλιοθήκες, προσφέροντας εκδηλώσεις, εκπαιδευτικά προγράμματα και εκθέσεις.
                    `,
    },
    {
        title: "Εθνική Βιβλιοθήκη της Ελλάδος - Πιστοποιημένοι Χρήστες",
        url: "https://www.nlg.gr/",
        category: "ΕκπαιδοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://www.nlg.gr/wp-content/uploads/2018/02/cropped-EBE-transparet-100x100.png",
        description:`
                        Η ΕΒΕ προσφέρει υπηρεσίες που απαιτούν πιστοποίηση χρηστών. Η εγγραφή επιτρέπει την πλήρη αξιοποίηση των υπηρεσιών της ΕΒΕ, όπως η πρόσβαση σε ηλεκτρονικές συλλογές και το ηλεκτρονικό αναγνωστήριο. Η διαδικασία εγγραφής και αναβάθμισης χρήστη περιλαμβάνει αναλυτικές οδηγίες στον Αναλυτικό και Συνοπτικό Οδηγό Εγγραφής Χρήστη.
                    `,
    },
    {
        title: "Εθνική Ακαδημία Ψηφιακών Δεξιοτήτων",
        url: "https://nationaldigitalacademy.gov.gr/",
        category: "ΕκπαιδοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://nationaldigitalacademy.gov.gr/favicon.ico",
        description:`
                        Η Εθνική Ακαδημία Ψηφιακών Δεξιοτήτων είναι πρωτοβουλία του Υπουργείου Ψηφιακής Διακυβέρνησης σε συνεργασία με το GRNET, με στόχο την ενίσχυση των ψηφιακών δεξιοτήτων όλων των πολιτών, συμπεριλαμβανομένων ηλικιωμένων, γυναικών και ΑμεΑ. Προσφέρει δωρεάν MOOCs και μαθήματα σε θεματικές όπως επικοινωνία, χρήση εργαλείων διαδικτύου, ψηφιακή επιχειρηματικότητα και τεχνολογίες αιχμής.  Διαθέτει εργαλείο αυτοαξιολόγησης για να εντοπίζουν οι χρήστες το επίπεδό τους και να ακολουθούν εξατομικευμένες διαδρομές μάθησης. Υλοποιεί εθνικά και ευρωπαϊκά έργα, όπως πρωτοβουλίες WomenInTech και δράσεις για την τρίτη ηλικία, ενισχύοντας τη συμμετοχή και ισότητα στον ψηφιακό κόσμο.
                    `,
    },
    {
        title: "Εθνικός Οργανισμός Πιστοποίησης Προσόντων και Επαγγελματικού Προσανατολισμού",
        url: "https://www.eoppep.gr/index.php/el/",
        category: "ΕκπαιδοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://www.eoppep.gr/images/icons/favicon.png",
        description:`
                        Ο ΕΟΠΠΕΠ είναι ο αρμόδιος φορέας στην Ελλάδα για την πιστοποίηση προσόντων και τον επαγγελματικό προσανατολισμό. Παρέχει υπηρεσίες όπως εξετάσεις πιστοποίησης επαγγελματικής επάρκειας, αναγνώριση ισοτιμιών τίτλων σπουδών, αδειοδότηση φορέων εκπαίδευσης και κατάρτισης, καθώς και υποστήριξη για την ανάπτυξη εκπαιδευτικής επάρκειας εκπαιδευτών ενηλίκων.
                    `,
    },
    {
        title: "Ίδρυμα Κρατικών Υποτροφιών (ΙΚΥ)",
        url: "https://www.iky.gr/",
        category: "ΕκπαιδοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://www.iky.gr/favicon.ico",
        description:`
                        Το Ίδρυμα Κρατικών Υποτροφιών (ΙΚΥ) είναι ο Εθνικός Φορέας Υποτροφιών της Ελλάδας. Προσφέρει υποτροφίες για προπτυχιακές, μεταπτυχιακές και ερευνητικές σπουδές στην Ελλάδα και το εξωτερικό. Υποστηρίζει ευπαθείς κοινωνικές ομάδες με υποτροφίες προάγοντας την έγκαιρη ολοκλήρωση σπουδών και την ισότιμη πρόσβαση στην ανώτατη εκπαίδευση. Διαχειρίζεται προγράμματα διεθνούς συνεργασίας, ενισχύοντας την ερευνητική κινητικότητα καθώς και κληροδοτήματα, χορηγώντας υποτροφίες από τα έσοδά τους. Βραβεύει επίσης την αριστεία σε διεθνείς διαγωνισμούς.
                    `,
    },
    {
        title: "Ανώτατο Συμβούλιο Επιλογής Προσωπικού (ΑΣΕΠ)",
        url: "https://www.asep.gr/",
        category: "ΕκπαιδοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://www.asep.gr/favicon.ico",
        description:`
                        Το Ανώτατο Συμβούλιο Επιλογής Προσωπικού (ΑΣΕΠ) αποτελεί τον κεντρικό φορέα επιλογής προσωπικού για τον δημόσιο και ευρύτερο δημόσιο τομέα. Διοργανώνει πανελλήνιους διαγωνισμούς για προσλήψεις σε όλες τις ειδικότητες και εξασφαλίζει τη στελέχωση των δημόσιων υπηρεσιών. Διαθέτει ψηφιακή πλατφόρμα μέσω του gov.gr όπου οι πολίτες μπορούν να υποβάλλουν και να διαχειρίζονται αιτήσεις για συμμετοχή σε διαγωνισμούς.  Το ΑΣΕΠ διασφαλίζει ότι οι δημόσιες υπηρεσίες στελεχώνονται με το καταλληλότερο και πιο ικανό προσωπικό μέσω διαφανών και αξιοκρατικών διαδικασιών.
                    `,
    },
    {
        title: "Εθνικό Κέντρο Δημόσιας Διοίκησης και Αυτοδιοίκησης (ΕΚΔΔΑ)",
        url: "https://www.ekdd.gr/",
        category: "ΕκπαιδοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://t0.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.ekdd.gr/&size=128",
        description:`
                        Το Εθνικό Κέντρο Δημόσιας Διοίκησης και Αυτοδιοίκησης (ΕΚΔΔΑ) αποτελεί τον κεντρικό φορέα επιμόρφωσης και ανάπτυξης του ανθρώπινου δυναμικού της δημόσιας διοίκησης, διασφαλίζοντας υψηλή ποιότητα υπηρεσιών προς τους πολίτες μέσω της εκπαίδευσης των δημοσίων υπαλλήλων. Έχει αναπτύξει σύγχρονο σύστημα πιστοποίησης επιμόρφωσης και προσφέρει καινοτόμες επιμορφωτικές δράσεις όπως προγράμματα τεχνητής νοημοσύνης για την καθημερινή εργασία, προωθώντας τον ψηφιακό εκσυγχρονισμό της δημόσιας διοίκησης.
                    `,
    },
    {
        title: "Ίδρυμα Επιμόρφωσης Προσωπικού (ΙΝ.ΕΠ.)",
        url: "https://www.ekdd.gr/category/inep/",
        category: "ΕκπαιδοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://t0.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.ekdd.gr/&size=128",
        description:`
                        Το Ίδρυμα Επιμόρφωσης Προσωπικού (ΙΝ.ΕΠ.) αποτελεί το κεντρικό όργανο επιμόρφωσης και κατάρτισης του προσωπικού της δημόσιας διοίκησης και αυτοδιοίκησης και στοχεύει στην εκσυγχρονισμένη παροχή υπηρεσιών προς τους πολίτες. Μέσω της στρατηγικής επιμόρφωσης που προσφέρει, συμβάλλει στη βελτίωση της ποιότητας και αποδοτικότητας των δημόσιων υπηρεσιών που παρέχονται στους πολίτες, ενώ παράλληλα αναπτύσσει τις ικανότητες των στελεχών για αποτελεσματικότερη εξυπηρέτηση του κοινού.
                    `,
    },

    {
        title: "Your Europe",
        url: "https://europa.eu/youreurope/citizens/education/university/study-abroad/index_el.htm",
        category: "ΕκπαιδοΕυρωπαϊκοί Οργανισμοί",
        imgUrl: "https://europa.eu/favicon.ico",
        description:`
                        Η ιστοσελίδα της Ευρωπαϊκής Ένωσης «Your Europe» παρέχει πληροφορίες για σπουδές εντός της ΕΕ, εστιάζοντας σε ευκαιρίες ανώτατης εκπαίδευσης. Δίνει πληροφορίες για το πρόγραμμα Erasmus+, το οποίο υποστηρίζει τη φοιτητική κινητικότητα με υποτροφίες για σπουδές ή πρακτική άσκηση σε άλλες ευρωπαϊκές χώρες. Περιγράφει τη διαδικασία αναγνώρισης πτυχίων μέσω του συστήματος ECTS για τη διευκόλυνση της ακαδημαϊκής και επαγγελματικής κινητικότητας. Παρέχει καθοδήγηση για δίδακτρα, υποτροφίες και πρακτικά ζητήματα, όπως ασφάλιση υγείας και διαμονή, ανάλογα με τη χώρα προορισμού. Περιλαμβάνει συνδέσμους προς εθνικούς φορείς και πόρους για περαιτέρω πληροφορίες σχετικά με τις ευκαιρίες σπουδών στην ΕΕ.
                    `,
    },
    {
        title: "Ευρωπαϊκό Συμβούλιο - Εκπαίδευση και κατάρτιση",
        url: "https://www.consilium.europa.eu/el/topics/education-training/",
        category: "ΕκπαιδοΕυρωπαϊκοί Οργανισμοί",
        imgUrl: "https://www.consilium.europa.eu/favicon.ico",
        description:`
                        Η ιστοσελίδα του Ευρωπαϊκού Συμβουλίου για την εκπαίδευση και την κατάρτιση περιγράφει τις πολιτικές της ΕΕ για την ενίσχυση της ποιότητας και της ισότητας στην εκπαίδευση. Εστιάζει στην προώθηση της δια βίου μάθησης, της ψηφιακής εκπαίδευσης και των δεξιοτήτων για την πράσινη μετάβαση. Υποστηρίζει την κινητικότητα φοιτητών και εκπαιδευτικών, την αναγνώριση προσόντων μέσω του Ευρωπαϊκού Πλαισίου Προσόντων (EQF) και την ανάπτυξη ευρωπαϊκών πανεπιστημιακών δικτύων. Περιλαμβάνει πληροφορίες για πρωτοβουλίες, όπως η ενίσχυση της επαγγελματικής εκπαίδευσης και κατάρτισης (VET) και η υποστήριξη της καινοτομίας στην εκπαίδευση.
                    `,
    },
    {
        title: "Ευρωπαϊκό Συμβούλιο - Ευρωπαϊκός Χώρος Εκπαίδευσης",
        url: "https://www.consilium.europa.eu/el/policies/education-area/",
        category: "ΕκπαιδοΕυρωπαϊκοί Οργανισμοί",
        imgUrl: "https://www.consilium.europa.eu/favicon.ico",
        description:`
                        Η ιστοσελίδα του Ευρωπαϊκού Συμβουλίου περιγράφει το όραμα της ΕΕ για έναν ενιαίο εκπαιδευτικό χώρο, ενισχύοντας την ποιότητα και την ισότητα στην εκπαίδευση. Εστιάζει στη βελτίωση δεξιοτήτων, την προώθηση της δια βίου μάθησης και την υποστήριξη της ψηφιακής και πράσινης μετάβασης στα εκπαιδευτικά συστήματα. Υποστηρίζει την κινητικότητα φοιτητών και εκπαιδευτικών και την αναγνώριση προσόντων μέσω του συστήματος ECTS. Προωθεί τη συνεργασία μεταξύ κρατών-μελών για την ανάπτυξη κοινών εκπαιδευτικών πολιτικών και την ανταλλαγή βέλτιστων πρακτικών. Περιλαμβάνει πληροφορίες για πρωτοβουλίες όπως το Ευρωπαϊκό Πλαίσιο Προσόντων και τη δημιουργία ευρωπαϊκών πανεπιστημιακών δικτύων.
                    `,
    },
    {
        title: "Ευρωπαϊκό Πλαίσιο Επαγγελματικών Προσόντων (ΕΠΕΠ)",
        url: "https://europass.europa.eu/el/ergaleia-europass/eyropaiko-plaisio-epaggelmatikon-prosonton",
        category: "ΕκπαιδοΕυρωπαϊκοί Οργανισμοί",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://europass.europa.eu/&size=128",
        description:`
                        Η ιστοσελίδα για το Ευρωπαϊκό Πλαίσιο Επαγγελματικών Προσόντων (ΕΠΕΠ) περιγράφει ένα σύστημα που κατηγοριοποιεί τα προσόντα σε οκτώ επίπεδα, από βασικές δεξιότητες έως προηγμένες επαγγελματικές ικανότητες. Διευκολύνει την αναγνώριση και σύγκριση προσόντων μεταξύ των χωρών της ΕΕ, προάγοντας την κινητικότητα εργαζομένων και φοιτητών. Υποστηρίζει τη διαφάνεια των δεξιοτήτων, παρέχει πληροφορίες για την εναρμόνιση εθνικών πλαισίων προσόντων με το ευρωπαϊκό και ενισχύει την εμπιστοσύνη σε πτυχία και πιστοποιητικά. Περιλαμβάνει πόρους για εργοδότες, εκπαιδευτικούς και ιδιώτες, με οδηγίες για την αξιοποίηση του πλαισίου στην εκπαίδευση και την αγορά εργασίας.
                    `,
    },
    {
        title: "Eurydice",
        url: "https://eurydice.eacea.ec.europa.eu/?etrans=el",
        category: "ΕκπαιδοΕυρωπαϊκοί Οργανισμοί",
        imgUrl: "https://eurydice.eacea.ec.europa.eu/themes/custom/eurydice/images/favicons/ec/favicon.ico",
        description:`
                        Ένα ευρωπαϊκό δίκτυο που παρέχει αξιόπιστες και συγκρίσιμες πληροφορίες για τα εκπαιδευτικά συστήματα και τις πολιτικές σε 40 χώρες της Ευρώπης καθώς και λεπτομερείς περιγραφές εθνικών εκπαιδευτικών συστημάτων, συγκριτικές μελέτες, στατιστικά στοιχεία και δείκτες που καλύπτουν όλα τα επίπεδα εκπαίδευσης.
                    `,
    },

    {
        title: "Education GPS του ΟΟΣΑ",
        url: "https://gpseducation.oecd.org/",
        category: "ΕκπαιδοΔιεθνείς Οργανισμοί",
        imgUrl: "https://gpseducation.oecd.org/Content/Images/logo/favicon.gif",
        description:`
                        Διαδραστική πλατφόρμα που προσφέρει συγκρίσιμα δεδομένα και αναλύσεις για τα εκπαιδευτικά συστήματα σε περισσότερες από 40 χώρες. Παρέχει πρόσβαση σε στατιστικά στοιχεία σχετικά με τη δομή, τη χρηματοδότηση και την απόδοση της εκπαίδευσης, βασισμένα σε διεθνείς αξιολογήσεις όπως το PISA και το TALIS. Οι χρήστες μπορούν να δημιουργήσουν προσαρμοσμένες αναφορές ανά χώρα ή θεματική ενότητα, να συγκρίνουν δείκτες και να εξερευνήσουν πολιτικές εκπαίδευσης.
                    `,
    },
    {
        title: "UNICEF Ελλάδας",
        url: "https://www.unicef.org/greece/",
        category: "ΕκπαιδοΔιεθνείς Οργανισμοί",
        imgUrl: "https://www.unicef.org/greece/themes/custom/unicef_base/assets/images/icons/favicon.ico",
        description:`
                        Εργάζεται για την προάσπιση των δικαιωμάτων κάθε παιδιού, δίνοντας έμφαση στα πιο ευάλωτα. Μέσω συνεργασιών με κρατικούς και τοπικούς φορείς, υλοποιεί προγράμματα που αφορούν την παιδική προστασία, την εκπαίδευση χωρίς αποκλεισμούς, την υγεία και την κοινωνική ένταξη προσφυγόπουλων. Επιπλέον, ενισχύει την παρακολούθηση των δικαιωμάτων του παιδιού και προωθεί την ενεργή συμμετοχή των νέων.
                    `,
    },
    {
        title: "Common Sense Media",
        url: "https://www.commonsensemedia.org/",
        category: "ΕκπαιδοΔιεθνείς Οργανισμοί",
        imgUrl: "https://www.commonsensemedia.org/themes/custom/common_sense/images/favicons/favicon-192x192.png",
        description:`
                        Μη κερδοσκοπικός οργανισμός που παρέχει αξιόπιστες αξιολογήσεις και οδηγούς για ταινίες, τηλεοπτικές σειρές, βιβλία, εφαρμογές, παιχνίδια και ψηφιακές πλατφόρμες, βοηθώντας γονείς και εκπαιδευτικούς να επιλέγουν κατάλληλο περιεχόμενο για παιδιά και εφήβους. Εκτός από τις αξιολογήσεις, προσφέρει επίσης, εκπαιδευτικά προγράμματα για την ψηφιακή εκπαίδευση και την υπεύθυνη χρήση της τεχνολογίας, καθώς και έρευνες για την επίδραση των μέσων στα παιδιά. Η πλατφόρμα του αποτελεί πολύτιμο εργαλείο για την ασφαλή πλοήγηση στον ψηφιακό κόσμο.
                    `,
    },
    {
        title: "Edutopia",
        url: "https://www.edutopia.org/",
        category: "ΕκπαιδοΔιεθνείς Οργανισμοί",
        imgUrl: "https://www.edutopia.org/assets/favicon.ico",
        description:`
                        Πρωτοβουλία του George Lucas Educational Foundation, αφιερωμένη στην ανάδειξη αποτελεσματικών πρακτικών στην εκπαίδευση προσχολικής έως δευτεροβάθμιας βαθμίδας. Προσφέρει δωρεάν άρθρα, βίντεο και εργαλεία που βασίζονται σε έρευνες και εμπειρίες εκπαιδευτικών, καλύπτοντας θεματικές όπως η μάθηση μέσω έργων, η κοινωνική και συναισθηματική μάθηση, η ενσωμάτωση τεχνολογίας και η επαγγελματική ανάπτυξη των εκπαιδευτικών.
                    `,
    },

    {
        title: "Ο Συνήγορος του Παιδιού",
        url: "https://www.synigoros.gr/paidi/",
        category: "ΕκπαιδοΑνεξάρτητες Αρχές",
        imgUrl: "https://www.synigoros.gr/favicon.ico",
        description:`
                        Ανεξάρτητη αρχή που προάγει και προστατεύει τα δικαιώματα των παιδιών στην Ελλάδα. Παρέχει δωρεάν και εμπιστευτική υποστήριξη σε παιδιά και εφήβους που αντιμετωπίζουν παραβιάσεις δικαιωμάτων, όπως κακοποίηση, σχολική διαρροή ή αποκλεισμό από κοινωνικές υπηρεσίες. Μέσω της ιστοσελίδας του, προσφέρει εργαλεία αναφοράς, ενημερωτικά υλικά και πρόσβαση σε δράσεις υπεράσπισης.
                    `,
    },
    {
        title: "Εθνική Αρχή Ανώτατης Εκπαίδευσης (ΕΘΑΑΕ)",
        url: "https://www.ethaae.gr/",
        category: "ΕκπαιδοΑνεξάρτητες Αρχές",
        imgUrl: "https://www.ethaae.gr/favicon.ico",
        description:`
                        Aνεξάρτητη διοικητική αρχή με στόχο τη διασφάλιση και την αναβάθμιση της ποιότητας στην ελληνική ανώτατη εκπαίδευση. Αξιολογεί και πιστοποιεί τα προγράμματα σπουδών και τα εσωτερικά συστήματα διασφάλισης ποιότητας των ΑΕΙ, εισηγείται για την κατανομή της δημόσιας χρηματοδότησης βάσει δεικτών ποιότητας και παρακολουθεί την πορεία των αποφοίτων. Η ιστοσελίδα της προσφέρει πρόσβαση σε εκθέσεις, γνωμοδοτήσεις, προκηρύξεις και ψηφιακές υπηρεσίες για τα ΑΕΙ και τους ενδιαφερόμενους πολίτες.
                    `,
    },

    {
        title: "Εθνικό Κέντρο Τεκμηρίωσης και Ηλεκτρονικού Περιεχομένου (ΕΚΤ)",
        url: "https://www.ekt.gr/",
        category: "ΕκπαιδοΕρευνητικοί Φορείς",
        imgUrl: "https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.ekt.gr/&size=128",
        description:`
                        Το Εθνικό Κέντρο Τεκμηρίωσης και Ηλεκτρονικού Περιεχομένου (ΕΚΤ) είναι φορέας εθνικής εμβέλειας εποπτευόμενος από το Υπουργείο Ψηφιακής Διακυβέρνησης. Συλλέγει, οργανώνει και διαχέει επιστημονικό, τεχνολογικό και πολιτιστικό περιεχόμενο, προάγοντας την έρευνα, την καινοτομία και τη ψηφιακή μετάβαση. Παρέχει υπηρεσίες όπως το Εθνικό Αρχείο Διδακτορικών Διατριβών, τον Εθνικό Συλλογικό Κατάλογο Επιστημονικών Περιοδικών και άλλα. Υποστηρίζει την ανοιχτή επιστήμη και πρόσβαση, ενώ παράγει στατιστικά στοιχεία για την έρευνα και ανάπτυξη στην Ελλάδα.
                    `,
    },
    {
        title: "Εθνικό Κέντρο Κοινωνικών Ερευνών (ΕΚΚΕ)",
        url: "https://www.ekke.gr/",
        category: "ΕκπαιδοΕρευνητικοί Φορείς",
        imgUrl: "https://t0.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.ekke.gr/&size=128",
        description:`
                        Το Εθνικό Κέντρο Κοινωνικών Ερευνών (ΕΚΚΕ) είναι ο μοναδικός δημόσιος φορέας αφιερωμένος στις κοινωνικές επιστήμες, υπό την εποπτεία της Γενικής Γραμματείας Έρευνας και Καινοτομίας. Διεξάγει έρευνες με έμφαση σε θέματα όπως η μετανάστευση, η κοινωνική συνοχή και οι ανισότητες υγείας. Παρέχει δεδομένα και υποδομές, όπως το Αποθετήριο Δεδομένων ΕΚΚΕ, το Πανόραμα Απογραφικών Δεδομένων και το Socioscope, υποστηρίζοντας την εμπειρική έρευνα. Διαθέτει βιβλιοθήκη με πρόσβαση σε ηλεκτρονικούς πόρους μέσω HEAL-Link και Web of Science. Συνεργάζεται με εθνικούς και διεθνείς φορείς, διοργανώνοντας εκδηλώσεις, όπως συνέδρια για έμφυλες διακρίσεις και παρουσιάσεις μελετών.
                    `,
    },
    {
        title: "Εθνικό Ίδρυμα Ερευνών (ΕΙΕ)",
        url: "https://www.eie.gr/",
        category: "ΕκπαιδοΕρευνητικοί Φορείς",
        imgUrl: "https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.eie.gr/&size=128",
        description:`
                        Το Εθνικό Ίδρυμα Ερευνών (ΕΙΕ) εποπτεύεται από τη Γενική Γραμματεία Έρευνας και Καινοτομίας. Εστιάζει σε διεπιστημονική έρευνα στους τομείς των ανθρωπιστικών, φυσικών και βιολογικών επιστημών μέσω τριών ινστιτούτων και παρέχει υπηρεσίες όπως η Βιβλιοθήκη Επιστήμης και Τεχνολογίας «Κ.Θ. Δημαράς», με πλούσιο ψηφιακό και έντυπο υλικό και το πρόγραμμα «Ανοιχτή Επιστήμη» για ελεύθερη πρόσβαση σε ερευνητικά δεδομένα. Διοργανώνει εκδηλώσεις, εκθέσεις και εκπαιδευτικά προγράμματα, ενώ υποστηρίζει την καινοτομία μέσω συνεργασιών με ακαδημαϊκούς και βιομηχανικούς φορείς.
                    `,
    },
    {
        title: "Εθνικό Αστεροσκοπείο Αθηνών (ΕΑΑ)",
        url: "https://www.noa.gr/",
        category: "ΕκπαιδοΕρευνητικοί Φορείς",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.noa.gr/&size=128",
        description:`
                        Το Εθνικό Αστεροσκοπείο Αθηνών (ΕΑΑ) είναι κορυφαίο ερευνητικό κέντρο και διαθέτει τρία ινστιτούτα: Γεωδυναμικό, Αστρονομίας-Αστροφυσικής-Διαστημικών Εφαρμογών-Τηλεπισκόπησης και Ερευνών Περιβάλλοντος-Βιώσιμης Ανάπτυξης. Παρέχει υπηρεσίες όπως καιρικές προβλέψεις (meteo.gr), παρακολούθηση σεισμών και πυρκαγιών. Διαχειρίζεται το τηλεσκόπιο «Αρίσταρχος» και υποστηρίζει την έρευνα. Προσφέρει εκπαιδευτικές δραστηριότητες και επισκέψεις στο Κέντρο Επισκεπτών.
                    `,
    },
    {
        title: "Δημόκριτος - Εθνικό Κέντρο Έρευνας Φυσικών Επιστημών (ΕΚΕΦΕ)",
        url: "https://www.demokritos.gr/el/",
        category: "ΕκπαιδοΕρευνητικοί Φορείς",
        imgUrl: "https://www.demokritos.gr/favicon.ico",
        description:`
                        Το ΕΚΕΦΕ «Δημόκριτος» είναι το μεγαλύτερο ερευνητικό κέντρο το οποίο εστιάζει σε: νανοτεχνολογία, ενέργεια, υγεία, πληροφορική και πυρηνική φυσική μέσω πέντε ινστιτούτων. Παρέχει υπηρεσίες όπως το Κέντρο Υπολογιστικού Νέφους και το Εργαστήριο Μετρήσεων Ακτινοβολίας. Υποστηρίζει την καινοτομία μέσω συνεργασιών με βιομηχανικές και spin-off εταιρείες. Προσφέρει εκπαιδευτικά προγράμματα και υποτροφίες για νέους επιστήμονες.
                    `,
    },
    {
        title: "Αθηνά",
        url: "https://www.athenarc.gr/",
        category: "ΕκπαιδοΕρευνητικοί Φορείς",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.athenarc.gr/&size=128",
        description:`
                        Το Ερευνητικό Κέντρο «Αθηνά» εστιάζει σε ψηφιακές τεχνολογίες και καινοτομία. Διαθέτει τρία ινστιτούτα: Βιομηχανικών Συστημάτων, Πληροφορικής-Τηλεπικοινωνιών και Επεξεργασίας Λόγου-Πληροφορίας. Παρέχει λύσεις σε τεχνητή νοημοσύνη, big data και διαχείριση πολιτιστικής κληρονομιάς. Συνεργάζεται με επιχειρήσεις και δημόσιους φορείς για τεχνολογική ανάπτυξη. Προσφέρει εκπαίδευση και υποδομές για έρευνα αιχμής.
                    `,
    },
    {
        title: "Γενική Γραμματεία Έρευνας και Καινοτομίας (ΓΓΕΚ)",
        url: "https://gsri.gov.gr/",
        category: "ΕκπαιδοΕρευνητικοί Φορείς",
        imgUrl: "https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://gsri.gov.gr/&size=128",
        description:`
                        Η Γενική Γραμματεία Έρευνας και Καινοτομίας (ΓΓΕΚ) συντονίζει την πολιτική έρευνας, τεχνολογικής ανάπτυξης και καινοτομίας στην Ελλάδα. Επιβλέπει ερευνητικά κέντρα και υποστηρίζει προγράμματα για νεοφυείς επιχειρήσεις και Κέντρα Ικανοτήτων. Διαχειρίζεται τη Στρατηγική Έξυπνης Εξειδίκευσης για χρηματοδότηση από το ΕΤΠΑ. Αντιπροσωπεύει την Ελλάδα σε ευρωπαϊκούς και διεθνείς οργανισμούς για την έρευνα.
                    `,
    },

    {
        title: "Αριστοτέλειο Πανεπιστήμιο Θεσσαλονίκης (ΑΠΘ)",
        url: "https://www.auth.gr/",
        category: "ΕκπαιδοΕλληνικά Δημόσια Πανεπιστήμια",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.auth.gr/&size=128",
    },
    {
        title: "Γεωπονικό Πανεπιστήμιο Αθηνών (ΓΠΑ)",
        url: "https://www.aua.gr/",
        category: "ΕκπαιδοΕλληνικά Δημόσια Πανεπιστήμια",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.aua.gr/&size=128",
    },
    {
        title: "Διεθνές Πανεπιστήμιο της Ελλάδος (ΔΙΠΑΕ)",
        url: "https://www.ihu.gr/",
        category: "ΕκπαιδοΕλληνικά Δημόσια Πανεπιστήμια",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.ihu.gr/&size=128",
    },
    {
        title: "Εθνικό και Καποδιστριακό Πανεπιστήμιο Αθηνών (ΕΚΠΑ)",
        url: "https://www.uoa.gr/",
        category: "ΕκπαιδοΕλληνικά Δημόσια Πανεπιστήμια",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.uoa.gr/&size=128",
    },
    {
        title: "Εθνικό Μετσόβιο Πολυτεχνείο (ΕΜΠ)",
        url: "https://www.ntua.gr/",
        category: "ΕκπαιδοΕλληνικά Δημόσια Πανεπιστήμια",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.ntua.gr/&size=128",
    },
    {
        title: "Ελληνικό Ανοικτό Πανεπιστήμιο (ΕΑΠ)",
        url: "https://www.eap.gr/",
        category: "ΕκπαιδοΕλληνικά Δημόσια Πανεπιστήμια",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.eap.gr/&size=128",
    },
    {
        title: "Ιόνιο Πανεπιστήμιο",
        url: "https://www.ionio.gr/",
        category: "ΕκπαιδοΕλληνικά Δημόσια Πανεπιστήμια",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.ionio.gr/&size=128",
    },
    {
        title: "Οικονομικό Πανεπιστήμιο Αθηνών (ΟΠΑ)",
        url: "https://www.aueb.gr/",
        category: "ΕκπαιδοΕλληνικά Δημόσια Πανεπιστήμια",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.aueb.gr/&size=128",
    },
    {
        title: "Πάντειο Πανεπιστήμιο Κοινωνικών και Πολιτικών Επιστημών",
        url: "https://www.panteion.gr/",
        category: "ΕκπαιδοΕλληνικά Δημόσια Πανεπιστήμια",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.panteion.gr/&size=128",
    },
    {
        title: "Πανεπιστήμιο Αιγαίου",
        url: "https://www.aegean.gr/",
        category: "ΕκπαιδοΕλληνικά Δημόσια Πανεπιστήμια",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.aegean.gr/&size=128",
    },
    {
        title: "Πανεπιστήμιο Δυτικής Αττικής (ΠΑΔΑ)",
        url: "https://www.uniwa.gr/",
        category: "ΕκπαιδοΕλληνικά Δημόσια Πανεπιστήμια",
        imgUrl: "https://www.uniwa.gr/wp-content/uploads/2018/11/icon.png",
    },
    {
        title: "Πανεπιστήμιο Δυτικής Μακεδονίας",
        url: "https://www.uowm.gr/",
        category: "ΕκπαιδοΕλληνικά Δημόσια Πανεπιστήμια",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.uowm.gr/&size=128",
    },
    {
        title: "Πανεπιστήμιο Θεσσαλίας",
        url: "https://www.uth.gr/",
        category: "ΕκπαιδοΕλληνικά Δημόσια Πανεπιστήμια",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.uth.gr/&size=128",
    },
    {
        title: "Πανεπιστήμιο Ιωαννίνων",
        url: "https://www.uoi.gr/",
        category: "ΕκπαιδοΕλληνικά Δημόσια Πανεπιστήμια",
        imgUrl: "https://uoi.gr/favicon.ico",
    },
    {
        title: "Πανεπιστήμιο Κρήτης",
        url: "https://www.uoc.gr/",
        category: "ΕκπαιδοΕλληνικά Δημόσια Πανεπιστήμια",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.uoc.gr/&size=128",
    },
    {
        title: "Πανεπιστήμιο Μακεδονίας (ΠΑΜΑΚ)",
        url: "https://www.uom.gr/",
        category: "ΕκπαιδοΕλληνικά Δημόσια Πανεπιστήμια",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.uom.gr/&size=128",
    },
    {
        title: "Πανεπιστήμιο Πατρών",
        url: "https://www.upatras.gr/",
        category: "ΕκπαιδοΕλληνικά Δημόσια Πανεπιστήμια",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.upatras.gr/&size=128",
    },
    {
        title: "Πανεπιστήμιο Πελοποννήσου",
        url: "https://www.uop.gr/",
        category: "ΕκπαιδοΕλληνικά Δημόσια Πανεπιστήμια",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.uop.gr/&size=128",
    },
    {
        title: "Πολυτεχνείο Κρήτης",
        url: "https://www.tuc.gr/",
        category: "ΕκπαιδοΕλληνικά Δημόσια Πανεπιστήμια",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.tuc.gr/&size=128",
    },
    {
        title: "Χαροκόπειο Πανεπιστήμιο",
        url: "https://www.hua.gr/",
        category: "ΕκπαιδοΕλληνικά Δημόσια Πανεπιστήμια",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.hua.gr/&size=128",
    },

    //Οικονομία

    {
        title: "Υπουργείο Εθνικής Οικονομίας και Οικονομικών",
        url: "https://minfin.gov.gr/",
        category: "ΟικονοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://minfin.gov.gr/favicon.ico",
        description:`
                        Το Υπουργείο Εθνικής Οικονομίας και Οικονομικών καθορίζει την οικονομική πολιτική της Ελλάδας, διαχειρίζεται το Taxisnet για φορολογικά θέματα, επιβλέπει τον κρατικό προϋπολογισμό και προωθεί επενδύσεις μέσω του Ταμείου Ανάκαμψης και του ΕΣΠΑ. Παρέχει επίσης ψηφιακές υπηρεσίες μέσω του Gov.gr.
                    `,
    },
    {
        title: "Τράπεζα της Ελλάδος",
        url: "https://www.bankofgreece.gr/",
        category: "ΟικονοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://www.bankofgreece.gr/SiteAssets/favicon.ico",
        description:`
                        Η Τράπεζα της Ελλάδος αποτελεί την κεντρική τράπεζα της χώρας, με κύρια αποστολή τη διασφάλιση της νομισματικής και χρηματοπιστωτικής σταθερότητας. Ο ιστότοπος προσφέρει πρόσβαση σε δημοσιεύσεις, έρευνες, στατιστικά δεδομένα και ενημερώσεις για τις δραστηριότητες της τράπεζας.
                    `,
    },
    {
        title: "e-katanalotis – Καλάθι Νοικοκυριού",
        url: "https://e-katanalotis.gov.gr/householdBasket/",
        category: "ΟικονοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://t1.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://e-katanalotis.gov.gr/&size=128",
        description:`
                        Η πλατφόρμα του Υπουργείου Ανάπτυξης προσφέρει καθημερινή ενημέρωση για τις τιμές βασικών προϊόντων σε μεγάλες αλυσίδες σουπερμάρκετ. Οι καταναλωτές μπορούν να συγκρίνουν τιμές, να δημιουργήσουν το δικό τους καλάθι και να παρακολουθούν τις μεταβολές, συμβάλλοντας στη διαφάνεια και την εξοικονόμηση.
                    `,
    },
    {
        title: "Energycost",
        url: "https://www.energycost.gr/",
        category: "ΟικονοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://www.energycost.gr/favicon.ico",
        description:`
                        Επίσημη πλατφόρμα σύγκρισης τιμών ρεύματος και φυσικού αερίου, που αναπτύχθηκε από τη ΡΑΑΕΥ (Ρυθμιστική Αρχή Αποβλήτων, Ενέργειας και Υδάτων). Επιτρέπει στους καταναλωτές να συγκρίνουν αντικειμενικά τιμολόγια όλων των παρόχων. Παρέχει διαφάνεια σε χρεώσεις, εκπτώσεις και όρους συμβολαίων. Η χρήση είναι δωρεάν και δεν απαιτεί εγγραφή.
                    `,
    },
    {
        title: "myAADE - Ψηφιακή Πύλη Πολιτών & Επιχειρήσεων της ΑΑΔΕ",
        url: "https://www1.aade.gr/aadeapps3/myaade/#!/",
        category: "ΟικονοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://t1.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.gsis.gr/&size=128",
        description:`
                        Ψηφιακή πύλη της ΑΑΔΕ, προσβάσιμη με κωδικούς TAXISnet με στόχο την πλήρη ηλεκτρονική διαχείριση φορολογικών υποθέσεων. Οι πολίτες μπορούν να υποβάλουν φορολογικές δηλώσεις, να εμφανίζουν αιτήματα, να κλείνουν ραντεβού στις ΔΟΥ και να αλλάζουν στοιχεία επικοινωνίας ή τραπεζικού ΙΒΑΝ.
                    `,
    },

    {
        title: "Ευρωπαϊκή Κεντρική Τράπεζα (ECB)",
        url: "https://www.ecb.europa.eu/ecb/html/index.el.html",
        category: "ΟικονοΕυρωπαϊκοί Οργανισμοί",
        imgUrl: "https://www.ecb.europa.eu/favicon.ico",
        description:`
                        Η Ευρωπαϊκή Κεντρική Τράπεζα (ECB) είναι υπεύθυνη για τη νομισματική πολιτική και τη διατήρηση της σταθερότητας των τιμών στη ζώνη του ευρώ. Εποπτεύει τα τραπεζικά ιδρύματα, διαχειρίζεται τα επίσημα συναλλαγματικά αποθέματα και συντονίζει την έκδοση τραπεζογραμματίων ευρώ. Προσφέρει επίσης στατιστικά στοιχεία, δημοσιογραφικές ανακοινώσεις, αναλύσεις και εκπαιδευτικό υλικό για το κοινό. Στόχος της είναι να διασφαλίσει τη χρηματοπιστωτική σταθερότητα και την ομαλή λειτουργία των αγορών πληρωμών και τραπεζών.
                    `,
    },
    {
        title: "Eurobarometer – Δημόσια Γνώμη στην Ευρωπαϊκή Ένωση",
        url: "https://europa.eu/eurobarometer/screen/home",
        category: "ΟικονοΕυρωπαϊκοί Οργανισμοί",
        imgUrl: "https://europa.eu/eurobarometer/angular/favicon.ico",
        description:`
                        Επίσημη πλατφόρμα της Ευρωπαϊκής Ένωσης για τη συλλογή και ανάλυση της κοινής γνώμης σε όλα τα κράτη μέλη. Παρέχει πρόσβαση σε αποτελέσματα ερευνών, αναλυτικά δεδομένα και διαδραστικά εργαλεία για την παρακολούθηση των τάσεων. Από το 1974, διεξάγει τακτικές πανευρωπαϊκές έρευνες που καλύπτουν θέματα όπως η πολιτική, η οικονομία, η κοινωνία, η υγεία, το περιβάλλον και η τεχνολογία.
                    `,
    },
    {
        title: "Eurostat – Στατιστικά της Ευρωπαϊκής Ένωσης",
        url: "https://ec.europa.eu/eurostat?etrans=el",
        category: "ΟικονοΕυρωπαϊκοί Οργανισμοί",
        imgUrl: "https://ec.europa.eu/eurostat/o/estat-theme-ecl/images/favicon.ico",
        description:`
                        Επίσημη στατιστική υπηρεσία της Ευρωπαϊκής Ένωσης, υπεύθυνη για τη συλλογή, επεξεργασία και δημοσίευση συγκρίσιμων στατιστικών στοιχείων για τα κράτη μέλη. Ο ιστότοπος προσφέρει πρόσβαση σε δεδομένα για την οικονομία, την κοινωνία, το περιβάλλον, την υγεία, την εκπαίδευση και άλλα κρίσιμα θέματα. Περιλαμβάνει διαδραστικά εργαλεία, βάσεις δεδομένων και στατιστικούς δείκτες για ανάλυση και σύγκριση.
                    `,
    },

    {
        title: "Στατιστικά στοιχεία του ΟΟΣΑ",
        url: "https://data.oecd.org/",
        category: "ΟικονοΔιεθνείς Οργανισμοί",
        imgUrl: "https://icons.duckduckgo.com/ip2/www.oecd.org.ico",
        description:`
                        Η επίσημη πλατφόρμα του Οργανισμού Οικονομικής Συνεργασίας και Ανάπτυξης (ΟΟΣΑ), που προσφέρει αξιόπιστα και συγκρίσιμα στατιστικά στοιχεία για τις χώρες-μέλη και άλλες οικονομίες. Παρέχει δεδομένα για την οικονομία, την εργασία, την παιδεία, τη φορολογία, την καινοτομία, το περιβάλλον και την ποιότητα ζωής. Προσφέρει εύχρηστα γραφήματα, διαδραστικά εργαλεία και θεματικοί δείκτες.
                    `,
    },
    {
        title: "Στατιστικά στοιχεία Ηνωμένων Εθνών",
        url: "https://data.un.org/",
        category: "ΟικονοΔιεθνείς Οργανισμοί",
        imgUrl: "https://data.un.org/_Images/favicon.ico",
        description:`
                        Επίσημη πλατφόρμα στατιστικών δεδομένων των Ηνωμένων Εθνών, η οποία παρέχει αξιόπιστα και συγκρίσιμα δεδομένα για όλα τα κράτη μέλη. Καλύπτει ευρύ φάσμα θεματικών τομέων όπως πληθυσμός, οικονομία, εκπαίδευση, υγεία, ενέργεια και περιβάλλον. Τα δεδομένα προέρχονται από εξειδικευμένους φορείς των ΗΕ και εθνικές στατιστικές υπηρεσίες.
                    `,
    },
    {
        title: "Στατιστικά στοιχεία της Παγκόσμιας Τράπεζας",
        url: "https://data.worldbank.org/",
        category: "ΟικονοΔιεθνείς Οργανισμοί",
        imgUrl: "https://data.worldbank.org/favicon.ico",
        description:`
                        Η πλατφόρμα προσφέρει ανοιχτή πρόσβαση σε στατιστικά στοιχεία για περισσότερες από 200 χώρες. Παρέχει αξιόπιστα δεδομένα για την οικονομική ανάπτυξη, τη φτώχεια, την εκπαίδευση, την υγεία, τη βιωσιμότητα και άλλους κρίσιμους τομείς. Τα δεδομένα χρησιμοποιούνται από κυβερνήσεις, ερευνητές και οργανισμούς χάραξης πολιτικής. Περιλαμβάνει εργαλεία ανάλυσης, διαδραστικούς χάρτες και θεματικούς δείκτες. Αποτελεί βασική πηγή για την παρακολούθηση των Παγκόσμιων Στόχων Βιώσιμης Ανάπτυξης.
                    `,
    },
    {
        title: "Οργανισμός Οικονομικής Συνεργασίας και Ανάπτυξης (ΟΟΣΑ)",
        url: "https://www.oecd.org/",
        category: "ΟικονοΔιεθνείς Οργανισμοί",
        imgUrl: "https://t0.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.oecd.org/&size=128",
        description:`
                        Ο Οργανισμός Οικονομικής Συνεργασίας και Ανάπτυξης (ΟΟΣΑ) είναι ένας διεθνής οργανισμός με 38 χώρες μέλη (και συνεργασίες με περισσότερες από 100), που προωθεί την οικονομική και κοινωνική ευημερία. Εμπλέκεται στη χάραξη πολιτικής μέσω στατιστικών, αναλύσεων και καθιέρωσης διεθνών προτύπων σε τομείς όπως η οικονομική ανάπτυξη, η εκπαίδευση, η ψηφιακή μετάβαση, η φορολογία και το περιβάλλον. Λειτουργεί ως πλατφόρμα πολυμερών διαβουλεύσεων με κυβερνήσεις, επιχειρήσεις, επαγγελματίες και ακαδημαϊκούς, ενώ δημοσιεύει περισσότερα από 500 μεγάλες μελέτες ετησίως και πάνω από 5 δισ. δεδομένα.
                    `,
    },
    {
        title: "Περιφερειακό Κέντρο Πληροφόρησης ΟΗΕ για την Ευρώπη",
        url: "https://unric.org/el/",
        category: "ΟικονοΔιεθνείς Οργανισμοί",
        imgUrl: "https://unric.org/favicon.ico",
        description:`
                       Με έδρα στις Βρυξέλλες καλύπτει 22 χώρες Δυτικής Ευρώπης (και της Ελλάδας), προωθώντας τις αξίες, τις δράσεις και τις εκθέσεις του ΟΗΕ στην ευρωπαϊκή κοινωνία. Διανέμει ενημερωτικό υλικό, έγγραφα και ενημερωτικά σημειώματα σε 13 ευρωπαϊκές γλώσσες, μεταξύ των οποίων και τα ελληνικά. Διοργανώνει καμπάνιες και εκδηλώσεις, προσφέρει πρόσβαση στη βιβλιοθήκη αναφορών, απαντά σε ερωτήματα και στηρίζει την ενσυνείδητη ενημέρωση για λύσεις σε παγκόσμια ζητήματα.
                    `,
    },

    {
        title: "Ελληνική Στατιστική Αρχή (ΕΛΣΤΑΤ) – Επίσημος Πάροχος Στατιστικών Δεδομένων της Ελλάδας",
        url: "https://www.statistics.gr/",
        category: "ΟικονοΑνεξάρτητες Αρχές",
        imgUrl: "https://www.statistics.gr/o/elstat-theme/images/favicon.ico",
        description:`
                        Η ΕΛΣΤΑΤ είναι η ανεξάρτητη αρχή που συλλέγει, επεξεργάζεται και δημοσιεύει επίσημα στατιστικά στοιχεία για την Ελλάδα. Προσφέρει πρόσβαση σε δεδομένα για την οικονομία, τον πληθυσμό, την απασχόληση, την υγεία, το περιβάλλον και άλλους τομείς. Διαθέτει εργαλεία αναζήτησης, διαδραστικούς χάρτες, μικροδεδομένα και εκδόσεις όπως «Η Ελλάδα με Αριθμούς» και «Η Ελληνική Οικονομία». Αποτελεί βασικό εργαλείο για ερευνητές, δημοσιογράφους, φορείς πολιτικής και πολίτες που αναζητούν αξιόπιστη στατιστική πληροφόρηση.
                    `,
    },
    {
        title: "Ανεξάρτητη Αρχή Δημοσίων Εσόδων (ΑΑΔΕ)",
        url: "https://www.aade.gr/",
        category: "ΟικονοΑνεξάρτητες Αρχές",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.aade.gr/&size=128",
        description:`
                        Η Ανεξάρτητη Αρχή Δημοσίων Εσόδων (ΑΑΔΕ) είναι υπεύθυνη για τη φορολογική διοίκηση, την είσπραξη φόρων και την καταπολέμηση της φοροδιαφυγής.
                    `,
    },

    {
        title: "Ελληνική Ένωση Τραπεζών (HBA)",
        url: "https://www.hba.gr/",
        category: "ΟικονοΤράπεζες",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://www.hba.gr/&size=128",
        description:`
                        Η Ελληνική Ένωση Τραπεζών (HBA) είναι Μη Κερδοσκοπικός Σύνδεσμος που εκπροσωπεί τις ελληνικές και ξένες τράπεζες στην Ελλάδα. Στόχοι της είναι η προώθηση και ανάπτυξη του τραπεζικού συστήματος, η προστασία των συμφερόντων των τραπεζών και η συμβολή στην οικονομική πρόοδο της χώρας. Συμμετέχει στη διαμόρφωση τραπεζικής νομοθεσίας, εκπροσωπώντας τα μέλη σε εθνικά και ευρωπαϊκά όργανα. Υποστηρίζει την τραπεζική εκπαίδευση, την έρευνα και την έρευνα μέσω δημοσιεύσεων, μελετών και του Hellenic Banking Institute. Ακόμα, αναπτύσσει δράσεις εταιρικής κοινωνικής ευθύνης και μηχανισμούς εξωδικαστικής επίλυσης διαφορών για καταναλωτές τραπεζικών υπηρεσιών.
                    `,
    },
    {
        title: "Ένωση Συνεταιριστικών Τραπεζών Ελλάδος (ΕΣΤΕ)",
        url: "https://www.este.gr/",
        category: "ΟικονοΤράπεζες",
        imgUrl: "https://www.este.gr/favicon.ico",
        description:`
                        Ιδρύθηκε το 1995 και εκπροσωπεί 4 συνεταιριστικές τράπεζες και 2 πιστωτικούς συνεταιρισμούς, λειτουργώντας ως κεντρικός φορέας στήριξης και υποστήριξης του θεσμού στην Ελλάδα. Στοχεύει στην ανάπτυξη και προώθηση της συνεταιριστικής πίστης, ενισχύοντας την τοπική ανάπτυξη μέσα από πελατοκεντρικές, ευέλικτες και κοινωνικά προσανατολισμένες υπηρεσίες. Διαχειρίζεται τη συνεργασία μεταξύ των μελών, προσφέρει νομική υποστήριξη, εκπαίδευση και ψηφιακή υποδομή για την αποτελεσματική λειτουργία τους.
                    `,
    },
    {
        title: "Alpha Bank",
        url: "https://www.alpha.gr/",
        category: "ΟικονοΤράπεζες",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.alpha.gr/&size=128",
    },
    {
        title: "Attica Bank",
        url: "https://www.atticabank.gr/",
        category: "ΟικονοΤράπεζες",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.atticabank.gr/&size=128",
    },
    {
        title: "Εθνική Τράπεζα της Ελλάδος Α.Ε.",
        url: "https://www.nbg.gr/",
        category: "ΟικονοΤράπεζες",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.nbg.gr/&size=128",
    },
    {
        title: "Ελληνική Αναπτυξιακή Τράπεζα",
        url: "https://www.hdb.gr/",
        category: "ΟικονοΤράπεζες",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://hdb.gr/&size=128",
    },
    {
        title: "Τράπεζα Eurobank Α.Ε.",
        url: "https://www.eurobank.gr/",
        category: "ΟικονοΤράπεζες",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.eurobank.gr/&size=128",
    },
    {
        title: "Optima Bank",
        url: "https://www.optimabank.gr/",
        category: "ΟικονοΤράπεζες",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.optimabank.gr/&size=128",
    },
    {
        title: "Τράπεζα Πειραιώς Α.Ε.",
        url: "https://www.piraeusbank.gr/",
        category: "ΟικονοΤράπεζες",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.piraeusbank.gr/&size=128",
    },
    {
        title: "Παγκρήτια Συνεταιριστική Τράπεζα",
        url: "https://www.pancretabank.gr/",
        category: "ΟικονοΤράπεζες",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.pancretabank.gr/&size=128",
    },
    {
        title: "Συνεταιριστική Τράπεζα Δράμας",
        url: "https://www.dramabank.gr/",
        category: "ΟικονοΤράπεζες",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.dramabank.gr/&size=128",
    },
    {
        title: "Συνεταιριστική Τράπεζα Ηπείρου",
        url: "https://www.epirusbank.gr/",
        category: "ΟικονοΤράπεζες",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.epirusbank.gr/&size=128",
    },
    {
        title: "Συνεταιριστική Τράπεζα Θεσσαλίας",
        url: "https://www.bankofthessaly.gr/",
        category: "ΟικονοΤράπεζες",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.bankofthessaly.gr/&size=128",
    },
    {
        title: "Συνεταιριστική Τράπεζα Καρδίτσας",
        url: "https://www.bankofkarditsa.gr/",
        category: "ΟικονοΤράπεζες",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.bankofkarditsa.gr/&size=128",
    },
    {
        title: "Συνεταιριστική Τράπεζα Χανίων",
        url: "https://www.chaniabank.gr/",
        category: "ΟικονοΤράπεζες",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.chaniabank.gr/&size=128",
    },

    //Εργασία

    {
        title: "Υπουργείο Εργασίας και Κοινωνικής Ασφάλισης",
        url: "https://ypergasias.gov.gr/",
        category: "ΕργατοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://ypergasias.gov.gr/favicon.ico",
        description:`
                        Το Υπουργείο Εργασίας και Κοινωνικής Ασφάλισης προωθεί πολιτικές για την απασχόληση και την κοινωνική προστασία. Διαχειρίζεται το Πληροφοριακό Σύστημα ΕΡΓΑΝΗ για εργασιακά δεδομένα και στατιστικές. Παρέχει πληροφορίες για εργασιακά δικαιώματα, ασφάλεια στην εργασία και συλλογικές συμβάσεις.
                    `,
    },
    {
        title: "Πληροφοριακό Σύστημα ΕΡΓΑΝΗ",
        url: "https://myergani.gov.gr/",
        category: "ΕργατοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://myergani.gov.gr&size=128",
        description:`
                        Η πλατφόρμα είναι το Πληροφοριακό Σύστημα ΕΡΓΑΝΗ του Υπουργείου Εργασίας. Παρέχει ψηφιακές υπηρεσίες για εργοδότες και εργαζόμενους, όπως καταχώριση συμβάσεων και ωραρίων. Υποστηρίζει την υποβολή δηλώσεων για απομακρυσμένη εργασία και υπερωρίες και επιτρέπει την έκδοση βεβαιώσεων εργασίας και την παρακολούθηση εργασιακών δεδομένων. Απαιτεί σύνδεση με κωδικούς Taxisnet για πρόσβαση στις υπηρεσίες.
                    `,
    },
    {
        title: "Εθνική Ακαδημία Ψηφιακών Δεξιοτήτων",
        url: "https://nationaldigitalacademy.gov.gr/",
        category: "ΕργατοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://nationaldigitalacademy.gov.gr/favicon.ico",
        description:`
                        Η Εθνική Ακαδημία Ψηφιακών Δεξιοτήτων είναι πρωτοβουλία του Υπουργείου Ψηφιακής Διακυβέρνησης σε συνεργασία με το GRNET, με στόχο την ενίσχυση των ψηφιακών δεξιοτήτων όλων των πολιτών, συμπεριλαμβανομένων ηλικιωμένων, γυναικών και ΑμεΑ. Προσφέρει δωρεάν εξ αποστάσεως μαθήματα σε θεματικές όπως: επικοινωνία, χρήση εργαλείων διαδικτύου, ψηφιακή επιχειρηματικότητα και τεχνολογίες αιχμής. Διαθέτει εργαλείο αυτοαξιολόγησης για να εντοπίζουν οι χρήστες το επίπεδό τους και να ακολουθούν εξατομικευμένες διαδρομές μάθησης.  Υλοποιεί εθνικά και ευρωπαϊκά έργα, όπως πρωτοβουλίες WomenInTech και δράσεις για την τρίτη ηλικία, ενισχύοντας τη συμμετοχή και ισότητα στον ψηφιακό κόσμο.
                    `,
    },
    {
        title: "e-ΕΦΚΑ",
        url: "https://www.efka.gov.gr/el",
        category: "ΕργατοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://t1.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.efka.gov.gr/&size=128",
        description:`
                        Ο e-ΕΦΚΑ είναι η ηλεκτρονική πλατφόρμα του Εθνικού Φορέα Κοινωνικής Ασφάλισης για ψηφιακές υπηρεσίες προς όλους τους ασφαλισμένους. Προσφέρει εκατοντάδες ηλεκτρονικές υπηρεσίες όπως βεβαιώσεις, αιτήσεις επιδομάτων, αποδεικτικά ενημερότητας και διαχείριση συντάξεων. Δίνει δυνατότητα στους πολίτες για κλείσιμο ραντεβού και παρακολούθηση αιτήσεων. Ενοποιεί όλες τις ασφαλιστικές υπηρεσίες σε μία ψηφιακή πλατφόρμα για γρήγορη και αξιόπιστη εξυπηρέτηση των πολιτών.
                    `,
    },
    {
        title: "Κέντρο Είσπραξης Ασφαλιστικών Οφειλών (ΚΕΑΟ)",
        url: "https://www.efka.gov.gr/el/elektronikes-yperesies/elektronikes-yperesies-keao",
        category: "ΕργατοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://t1.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.efka.gov.gr/&size=128",
        description:`
                        Το Κέντρο Είσπραξης Ασφαλιστικών Οφειλών (ΚΕΑΟ) προσφέρει ηλεκτρονικές υπηρεσίες για τη διαχείριση ασφαλιστικών οφειλών που έχουν διαβιβαστεί από τον e-ΕΦΚΑ. Η πρόσβαση γίνεται με κωδικούς TAXISnet. Υποστηρίζει την πιστοποίηση οφειλετών ανά ΑΦΜ και δίνει ενοποιημένη εικόνα των οφειλών.
                    `,
    },
    {
        title: "Δημόσια Υπηρεσία Απασχόλησης (Δ.ΥΠ.Α.)",
        url: "https://www.dypa.gov.gr/",
        category: "ΕργατοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://t0.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.dypa.gov.gr/&size=128",
        description:`
                        Η Δημόσια Υπηρεσία Απασχόλησης (Δ.ΥΠ.Α.) προσφέρει υπηρεσίες σχετικές με την ανεργία και την απασχόληση. Παρέχει υπηρεσίες όπως: έκδοση/ανανέωση κάρτας ανεργίας, δωρεάν κόμιστρο ATH.ENA card και προγράμματα κατάρτισης.  Παρέχει επίσης ένα εκτεταμένο σύνολο ηλεκτρονικών υπηρεσιών προς πολίτες, επιχειρήσεις και τρίτους φορείς.  Στοχεύει στη δημιουργία νέων ευκαιριών απασχόλησης με έμφαση στη βιωσιμότητα και την υπεύθυνη επιχειρηματικότητα.
                    `,
    },
    {
        title: "Ανώτατο Συμβούλιο Επιλογής Προσωπικού (ΑΣΕΠ)",
        url: "https://www.asep.gr/",
        category: "ΕργατοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://www.asep.gr/favicon.ico",
        description:`
                        Το Ανώτατο Συμβούλιο Επιλογής Προσωπικού (ΑΣΕΠ) αποτελεί τον κεντρικό φορέα επιλογής προσωπικού για τον δημόσιο και ευρύτερο δημόσιο τομέα. Διοργανώνει πανελλήνιους διαγωνισμούς για προσλήψεις σε όλες τις ειδικότητες και εξασφαλίζει τη στελέχωση των δημόσιων υπηρεσιών. Διαθέτει ψηφιακή πλατφόρμα μέσω του gov.gr όπου οι πολίτες μπορούν να υποβάλλουν και να διαχειρίζονται αιτήσεις για συμμετοχή σε διαγωνισμούς.  Το ΑΣΕΠ διασφαλίζει ότι οι δημόσιες υπηρεσίες στελεχώνονται με το καταλληλότερο και πιο ικανό προσωπικό μέσω διαφανών και αξιοκρατικών διαδικασιών.
                    `,
    },
    {
        title: "Αριθμός Μητρώου Κοινωνικής Ασφάλισης (ΑΜΚΑ)",
        url: "https://www.amka.gr/",
        category: "ΕργατοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://t0.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.amka.gr/&size=128",
        description:`
                        Ο Αριθμός Μητρώου Κοινωνικής Ασφάλισης (ΑΜΚΑ) αποτελεί την ηλεκτρονική πλατφόρμα της Η.ΔΙ.Κ.Α. Παρέχει στους πολίτες τη δυνατότητα αναζήτησης και επαλήθευσης του αριθμού μητρώου κοινωνικής ασφάλισης, ο οποίος είναι απαραίτητος για την πρόσβαση σε υπηρεσίες υγείας και κοινωνικής ασφάλισης. Η υπηρεσία διαθέτει επίσης ειδική λειτουργία μαζικής αναζήτησης για εργοδότες, επιτρέποντάς τους να επαληθεύουν τα στοιχεία των εργαζομένων τους για ασφαλιστικούς σκοπούς.
                    `,
    },
    {
        title: "Διαύγεια",
        url: "https://diavgeia.gov.gr/",
        category: "ΕργατοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://t0.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://diavgeia.gov.gr/&size=128",
        description:`
                        Η Διαύγεια είναι η επίσημη κυβερνητική πύλη για την ανάρτηση δημόσιων πράξεων και αποτελεί βασικό εργαλείο διαφάνειας του δημόσιου τομέα, επιτρέποντας στους πολίτες την πρόσβαση σε δημόσιες πράξεις και αποφάσεις.
                    `,
    },
    {
        title: "Εθνικό Κέντρο Δημόσιας Διοίκησης και Αυτοδιοίκησης (ΕΚΔΔΑ)",
        url: "https://www.ekdd.gr/",
        category: "ΕργατοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.ekdd.gr/&size=128",
        description:`
                        Το Εθνικό Κέντρο Δημόσιας Διοίκησης και Αυτοδιοίκησης (ΕΚΔΔΑ) αποτελεί τον κεντρικό φορέα επιμόρφωσης και ανάπτυξης του ανθρώπινου δυναμικού της δημόσιας διοίκησης, διασφαλίζοντας υψηλή ποιότητα υπηρεσιών προς τους πολίτες μέσω της εκπαίδευσης των δημοσίων υπαλλήλων. Έχει αναπτύξει σύγχρονο σύστημα πιστοποίησης επιμόρφωσης και προσφέρει καινοτόμες επιμορφωτικές δράσεις όπως προγράμματα τεχνητής νοημοσύνης για την καθημερινή εργασία, προωθώντας τον ψηφιακό εκσυγχρονισμό της δημόσιας διοίκησης.
                    `,
    },
    {
        title: "Ίδρυμα Επιμόρφωσης Προσωπικού (ΙΝ.ΕΠ.)",
        url: "https://www.ekdd.gr/category/inep/",
        category: "ΕργατοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.ekdd.gr/&size=128",
        description:`
                        Το Ίδρυμα Επιμόρφωσης Προσωπικού (ΙΝ.ΕΠ.) αποτελεί το κεντρικό όργανο επιμόρφωσης και κατάρτισης του προσωπικού της δημόσιας διοίκησης και αυτοδιοίκησης και στοχεύει στην εκσυγχρονισμένη παροχή υπηρεσιών προς τους πολίτες. Μέσω της στρατηγικής επιμόρφωσης που προσφέρει, συμβάλλει στη βελτίωση της ποιότητας και αποδοτικότητας των δημόσιων υπηρεσιών που παρέχονται στους πολίτες, ενώ παράλληλα αναπτύσσει τις ικανότητες των στελεχών για αποτελεσματικότερη εξυπηρέτηση του κοινού.
                    `,
    },
    {
        title: "ΑΤΛΑΣ",
        url: "https://www.atlas.gov.gr/",
        category: "ΕργατοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://t1.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.atlas.gov.gr/Atlas/Pages/Home.aspx&size=128",
        description:`
                        Το σύστημα ΑΤΛΑΣ είναι το Μητρώο Ασφάλισης-Ασφαλιστικής Ικανότητας που επιτρέπει στους ασφαλισμένους να δουν τα ένσημά τους online με τη χρήση του ΑΜΚΑ και των κωδικών Taxisnet. Μέσω της λειτουργίας «Ασφαλιστικό Βιογραφικό» οι πολίτες μπορούν να εμφανίσουν στην οθόνη τους συνοπτικά τα διαστήματα ασφάλισης σε κάθε φορέα και με την επιλογή εκτύπωση να δουν αναλυτικά την πλήρη ανάλυση του χρόνου ασφάλισης.
                    `,
    },

    {
        title: "WHEN - Ενδυνάμωση και Ισότητα για Όλες",
        url: "https://when.org.gr/",
        category: "ΕργατοΜη Κυβερνητικοί Οργανισμοί",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://when.org.gr/&size=128",
        description:`
                        Μη κερδοσκοπικός οργανισμός που προωθεί την επαγγελματική και οικονομική ενδυνάμωση των γυναικών και την έμφυλη ισότητα στην εργασία και την κοινωνία. Μέσα από προγράμματα mentoring, εργασιακή συμβουλευτική, σεμινάρια δεξιοτήτων και δράσεις ευαισθητοποίησης, υποστηρίζει γυναίκες, επιχειρήσεις και εκπαιδευτικούς. Το WHEN Hub προσφέρει υποδομές για εργασία, εκπαίδευση και δημιουργική απασχόληση.
                    `,
    },

    {
        title: "EURES (Ευρωπαϊκές Υπηρεσίες Απασχόλησης)",
        url: "https://eures.europa.eu/index_el",
        category: "ΕργατοΕυρωπαϊκοί Οργανισμοί",
        imgUrl: "https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://eures.europa.eu/index_el&size=128",
        description:`
                        Το EURES (Ευρωπαϊκές Υπηρεσίες Απασχόλησης) είναι ευρωπαϊκό δίκτυο που συνδέει εργαζόμενους και εργοδότες σε όλη την ΕΕ και τις χώρες ΕΖΕΣ (Ελβετία, Ισλανδία, Λιχτενστάιν, Νορβηγία). Προσφέρει υπηρεσίες αναζήτησης εργασίας και πρόσληψης προσωπικού, καθώς και εξατομικευμένες συμβουλές για κινητικότητα εργαζομένων. Διαθέτει ενημερωτικά άρθρα για σύγχρονα θέματα εργασίας όπως ψηφιοποίηση, ασφάλεια εργασίας, αξιολόγηση απόδοσης και μελλοντικές τάσεις της αγοράς εργασίας.
                    `,
    },

    {
        title: "Γενική Συνομοσπονδία Εργατών Ελλάδας (ΓΣΕΕ)",
        url: "https://gsee.gr/",
        category: "ΕργατοΙδρύματα - Οργανισμοί",
        imgUrl: "https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://gsee.gr/&size=128",
        description:`
                        Η Γενική Συνομοσπονδία Εργατών Ελλάδας (ΓΣΕΕ) αποτελεί την κεντρική συνδικαλιστική οργάνωση των εργατών στην Ελλάδα που εκπροσωπεί τα συμφέροντα των εργαζομένων σε εθνικό επίπεδο. Διαθέτει το Κέντρο Προστασίας Εργαζομένων και Ανέργων που προσφέρει πρακτικά εργαλεία υπολογισμού εργασιακών δικαιωμάτων όπως αποζημιώσεις απόλυσης, υπερωρίες και επιδόματα. Δημοσιεύει τακτικά δελτία τύπου και ενημερώσεις για εργασιακά θέματα, συμπεριλαμβανομένων αμοιβών για αργίες και επιστολών προς κυβερνητικούς φορείς.
                    `,
    },
    {
        title: "Κέντρο Ανάπτυξης Εκπαιδευτικής Πολιτικής",
        url: "https://www.kanep-gsee.gr/",
        category: "ΕργατοΙδρύματα - Οργανισμοί",
        imgUrl: "https://www.kanep-gsee.gr/favicon.ico",
        description:`
                        Το Κέντρο Ανάπτυξης Εκπαιδευτικής Πολιτικής αποτελεί τον εκπαιδευτικό, επιστημονικό και ερευνητικό φορέα της ΓΣΕΕ που στοχεύει στη βελτίωση των υπηρεσιών προς τους εργαζόμενους μέσω ποιοτικής επιμόρφωσης και εκπαίδευσης. Υλοποιεί προγράμματα δια βίου εκπαίδευσης για εργαζόμενους του ιδιωτικού και δημόσιου τομέα καθώς και για αυτοαπασχολούμενους με στόχο την ανάπτυξη οριζόντιων και κοινωνικών δεξιοτήτων.
                    `,
    },
    {
        title: "Ανώτατη Διοίκηση Ενώσεων Δημοσίων Υπαλλήλων (ΑΔΕΔΥ)",
        url: "https://www.adedy.gr/",
        category: "ΕργατοΙδρύματα - Οργανισμοί",
        imgUrl: "https://www.adedy.gr/favicon.ico",
        description:`
                        Η Ανώτατη Διοίκηση Ενώσεων Δημοσίων Υπαλλήλων (ΑΔΕΔΥ) αποτελεί τον κεντρικό συνδικαλιστικό φορέα των εργαζομένων του δημοσίου τομέα. Τα μέλη της αποτελούν οι υπάλληλοι των υπηρεσιών του δημοσίου, των νομικών προσώπων δημοσίου δικαίου και των ΟΤΑ (Οργανισμών Τοπικής Αυτοδιοίκησης). Μέσω της δράσης της διασφαλίζει την ποιότητα των δημόσιων υπηρεσιών προς τους πολίτες, καθώς αγωνίζεται για βελτίωση των συνθηκών εργασίας του προσωπικού που στελεχώνει τις κρίσιμες κοινωνικές υπηρεσίες.
                    `,
    },

    //Περιβάλλον

    {
        title: "Υπουργείο Περιβάλλοντος και Ενέργειας (ΥΠΕΝ)",
        url: "https://ypen.gov.gr/",
        category: "ΠεριβαλλοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://ypen.gov.gr/favicon.ico",
        description:`
                        Το Υπουργείο Περιβάλλοντος και Ενέργειας (ΥΠΕΝ) σχεδιάζει πολιτικές για την προστασία του περιβάλλοντος και την ενεργειακή μετάβαση. Ελέγχει τη δασική πολιτική, την πολεοδομία και τη διαχείριση αποβλήτων, ενώ προωθεί τις ανανεώσιμες πηγές ενέργειας για κλιματική ουδετερότητα.
                    `,
    },
    {
        title: "Γενική Γραμματεία Πολιτικής Προστασίας (Γ.Γ.Π.Π.)",
        url: "https://civilprotection.gov.gr/",
        category: "ΠεριβαλλοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://civilprotection.gov.gr/favicon.ico",
        description:`
                        Η Γενική Γραμματεία Πολιτικής Προστασίας (Γ.Γ.Π.Π.) λειτουργεί ως κεντρικός συντονιστικός φορέας για την πολιτική προστασία στη χώρα.
                    `,
    },
    {
        title: "Χάρτης Πρόβλεψης Κινδύνου Πυρκαγιάς",
        url: "https://civilprotection.gov.gr/xartis/",
        category: "ΠεριβαλλοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://civilprotection.gov.gr/favicon.ico",
        description:`
                        Καθημερινή ενημέρωση για τον κίνδυνο εκδήλωσης δασικών πυρκαγιών στην Ελλάδα. Η πρόβλεψη ισχύει για την επόμενη ημέρα από την έκδοσή της και βασίζεται σε 4 κατηγορίες κινδύνου, από πολύ χαμηλό έως πολύ υψηλό (κατηγορία 4). Η ενημέρωση συμβάλλει στην ευαισθητοποίηση των πολιτών για την αποφυγή ενεργειών που ενδέχεται να προκαλέσουν πυρκαγιά από αμέλεια.
                    `,
    },
    {
        title: "Εθνικός Κόμβος Πληροφόρησης για την Ατμοσφαιρική Σύσταση",
        url: "https://atmohub.gr/",
        category: "ΠεριβαλλοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://t1.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://atmohub.gr/&size=128",
        description:`
                        Ο Εθνικός Κόμβος Πληροφόρησης για την Ατμοσφαιρική Σύσταση στην Ελλάδα παρέχει καθημερινές προγνώσεις για σημαντικούς αέριους ρύπους (όπως O₃, NO₂, SO₂, PM2.5, PM10), γύρη, καπνό από πυρκαγιές, ηφαιστειακή τέφρα και σκόνη από την έρημο. Στόχος του είναι η ενίσχυση της δημόσιας υγείας και η υποστήριξη πολιτικών για την ποιότητα του αέρα μέσω ανοιχτών δεδομένων και εργαλείων ανάλυσης.
                    `,
    },
    {
        title: "Εθνικό Αστεροσκοπείο Αθηνών (ΕΑΑ)",
        url: "https://www.noa.gr/",
        category: "ΠεριβαλλοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.noa.gr/&size=128",
        description:`
                        Το Εθνικό Αστεροσκοπείο Αθηνών (ΕΑΑ) είναι κορυφαίο ερευνητικό κέντρο και διαθέτει τρία ινστιτούτα: Γεωδυναμικό, Αστρονομίας-Αστροφυσικής-Διαστημικών Εφαρμογών-Τηλεπισκόπησης και Ερευνών Περιβάλλοντος-Βιώσιμης Ανάπτυξης. Παρέχει υπηρεσίες όπως καιρικές προβλέψεις (meteo.gr), παρακολούθηση σεισμών και πυρκαγιών. Διαχειρίζεται το τηλεσκόπιο «Αρίσταρχος» και υποστηρίζει την έρευνα. Προσφέρει εκπαιδευτικές δραστηριότητες και επισκέψεις στο Κέντρο Επισκεπτών.
                    `,
    },
    {
        title: "Meteo",
        url: "https://www.meteo.gr/index.cfm",
        category: "ΠεριβαλλοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://www.meteo.gr/favicon.ico",
        description:`
                        Παρέχεται από τον Εθνικό Αστεροσκοπείο Αθηνών (ΕΑΑ) και δίνει έγκυρες και λεπτομερείς προβλέψεις καιρού για όλη την Ελλάδα, στηριζόμενο στο μεγαλύτερο μετεωρολογικό δίκτυο της χώρας. Προβάλλει δορυφορικές εικόνες, χάρτες σκόνης, ανέμου, κυμάτων, καταιγίδων και κεραυνών με συνεχείς ανανεώσεις. Παρέχει, επίσης, εξειδικευμένα δεδομένα για τη ναυσιπλοΐα, την γεωργία και πρόγνωση σε αρχαιολογικούς χώρους, δρόμους και παραλίες.
                    `,
    },
    {
        title: "Γεωδυναμικό Ινστιτούτο",
        url: "https://www.gein.noa.gr/",
        category: "ΠεριβαλλοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.noa.gr/&size=128",
        description:`
                        Το Γεωδυναμικό Ινστιτούτο αποτελεί μέρος του Εθνικού Αστεροσκοπείου Αθηνών και είναι υπεύθυνο για την έρευνα και την παρακολούθηση γεωδυναμικών φαινομένων όπως σεισμοί, τσουνάμι και τεκτονική δραστηριότητα. Λειτουργεί πανελλαδικό σεισμολογικό και επιταχυνσιομετρικό δίκτυο, παρέχοντας σε πραγματικό χρόνο δεδομένα, σεισμογράμματα, ShakeMaps και καταλόγους σεισμών. Παράλληλα, διαθέτει εκπαιδευτικά προγράμματα και υλικό για σχολεία και κοινό, ενώ συμμετέχει στο ευρωπαϊκό δίκτυο EIDA για διακρατική πρόσβαση σε σεισμικά δεδομένα.
                    `,
    },
    {
        title: "Εθνική Μετεωρολογική Υπηρεσία (ΕΜΥ)",
        url: "https://emy.gr/?area=forecast",
        category: "ΠεριβαλλοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://emy.gr/favicon.ico",
        description:`
                        Η Εθνική Μετεωρολογική Υπηρεσία (ΕΜΥ) είναι ο επίσημος φορέας πρόβλεψης καιρού στην Ελλάδα υπό την Πολεμική Αεροπορία και προσφέρει ακριβείς και ενημερωμένες προβλέψεις για όλη τη χώρα. Παρέχονται λεπτομερή μετεωρογράμματα ανά πόλη, πληροφορίες για θερμοκρασία, άνεμο, υγρασία και ιστορικά κλιματικά δεδομένα.
                    `,
    },
    {
        title: "Ελληνικό Κέντρο Θαλάσσιων Ερευνών (ΕΛΚΕΘΕ / HCMR)",
        url: "https://www.hcmr.gr/el/",
        category: "ΠεριβαλλοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.hcmr.gr/el/&size=128",
        description:`
                        Το Ελληνικό Κέντρο Θαλάσσιων Ερευνών (ΕΛΚΕΘΕ / HCMR) είναι δημόσιος ερευνητικός φορέας υπό τη Γενική Γραμματεία Έρευνας και Καινοτομίας, με αποστολή την επιστημονική έρευνα και προστασία της υδροσφαίρας και των παράκτιων οικοσυστημάτων. Διεξάγει πολυεπιστημονική έρευνα σε θαλάσσια οικοσυστήματα, βιοποικιλότητα, αλιεία, υδάτινους πόρους, αλλαγή κλίματος και θαλάσσια ρυπαντικά φαινόμενα. Παρέχει επιστημονική στήριξη σε φορείς, δημόσιες υπηρεσίες και την πολιτεία για περιβαλλοντική βιωσιμότητα, θαλάσσια στρατηγική, διαχείριση κινδύνων (π.χ. πετρελαιοκηλίδες, τσουνάμι, ολίσθηση παράκτιων εδαφών). Υποστηρίζει εκπαιδευτικά προγράμματα, δημόσιες ενημερώσεις και συνεργασίες σε εθνικό και διεθνές επίπεδο προωθώντας την θαλάσσια έρευνα και την καινοτομία.
                    `,
    },
    {
        title: "Γενική Γραμματεία Έρευνας και Καινοτομίας (ΓΓΕΚ)",
        url: "https://gsri.gov.gr/",
        category: "ΠεριβαλλοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://t1.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://gsri.gov.gr&size=128",
        description:`
                        Η Γενική Γραμματεία Έρευνας και Καινοτομίας (ΓΓΕΚ) συντονίζει την πολιτική έρευνας, τεχνολογικής ανάπτυξης και καινοτομίας στην Ελλάδα. Επιβλέπει ερευνητικά κέντρα και υποστηρίζει προγράμματα για νεοφυείς επιχειρήσεις και Κέντρα Ικανοτήτων. Διαχειρίζεται τη Στρατηγική Έξυπνης Εξειδίκευσης για χρηματοδότηση από το ΕΤΠΑ. Αντιπροσωπεύει την Ελλάδα σε ευρωπαϊκούς και διεθνείς οργανισμούς για την έρευνα.
                    `,
    },
    {
        title: "Ινστιτούτο Ωκεανογραφίας του ΕΛΚΕΘΕ",
        url: "https://www.hcmr.gr/el/Δεδομένα-Αποθετήρια/hnodc/",
        category: "ΠεριβαλλοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.hcmr.gr/el/%CE%94%CE%B5%CE%B4%CE%BF%CE%BC%CE%AD%CE%BD%CE%B1-%CE%91%CF%80%CE%BF%CE%B8%CE%B5%CF%84%CE%AE%CF%81%CE%B9%CE%B1/hnodc/&size=128",
        description:`
                        Το Ινστιτούτο Ωκεανογραφίας του ΕΛΚΕΘΕ παρέχει πρόσβαση σε φυσικοχημικά και βιολογικά δεδομένα θαλασσών της Ανατολικής Μεσογείου και Μαύρης Θάλασσας μέσω της υπηρεσίας Search & Download. Προσφέρει επίσης τις υπηρεσίες EDMED και EDIOS με βάση διεθνή πρότυπα.
                    `,
    },

    {
        title: "Ευρωπαϊκό Πρόγραμμα Γεωσκόπησης Copernicus",
        url: "https://www.copernicus.eu/el/liga-logia-gia-copernicus",
        category: "ΠεριβαλλοΕυρωπαϊκοί Οργανισμοί",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.copernicus.eu&size=128",
        description:`
                        Το Ευρωπαϊκό Πρόγραμμα Γεωσκόπησης Copernicus είναι πρόγραμμα της Ευρωπαϊκής Ένωσης, το οποίο παρατηρεί το περιβάλλον και τον πλανήτη μας προς όφελος όλων των Ευρωπαίων πολιτών. Παρέχει υπηρεσίες πληροφόρησης με βάση δορυφορικά δεδομένα γεωσκόπησης και επίγεια (μη διαστημικά) δεδομένα.
                    `,
    },
    {
        title: "EU Climate Action",
        url: "https://climate.ec.europa.eu/index_en?prefLang=el&etrans=el/",
        category: "ΠεριβαλλοΕυρωπαϊκοί Οργανισμοί",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://climate.ec.europa.eu/&size=128",
        description:`
                        Η ιστοσελίδα της Ευρωπαϊκής Επιτροπής για την κλιματική δράση παρέχει πληροφορίες για τις στρατηγικές και τις πολιτικές της ΕΕ, με στόχο την κλιματική ουδετερότητα έως το 2050. Η πλατφόρμα απευθύνεται σε πολίτες, φορείς χάραξης πολιτικής, επιχειρήσεις και οργανισμούς, ενθαρρύνοντας τη συμμετοχή και την ενημέρωση για την κλιματική κρίση.
                    `,
    },

    {
        title: "Ευρωπαϊκό-Μεσογειακό Σεισμολογικό Κέντρο (EMSC)",
        url: "https://www.emsc.eu/",
        category: "ΠεριβαλλοΜη Κυβερνητικοί Οργανισμοί",
        imgUrl: "https://www.emsc.eu/favicon.ico",
        description:`
                        Το Ευρωπαϊκό-Μεσογειακό Σεισμολογικό Κέντρο (EMSC) είναι ένας διεθνής οργανισμός που συλλέγει δεδομένα από 70+ σεισμολογικά ινστιτούτα. Προσφέρει ταχύτερη ενημέρωση για σεισμούς μέσω της εφαρμογής LastQuake, η οποία ειδοποιεί σε πραγματικό χρόνο και παρέχει χάρτες έντασης και οδηγίες ασφαλείας. Το EMSC αποτελεί επίσημο μέρος του Ευρωπαϊκού Συστήματος Σεισμικών Ειδοποιήσεων.
                    `,
    },
    {
        title: "Γαλάζια Σημαία",
        url: "https://www.blueflag.gr/el/",
        category: "ΠεριβαλλοΜη Κυβερνητικοί Οργανισμοί",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.blueflag.gr/el&size=128",
        description:`
                        Το εθελοντικό πρόγραμμα «Γαλάζια Σημαία» συντονίζεται από την Ελληνική Εταιρία Προστασίας της Φύσης και αποτελεί την επίσημη πρωτοβουλία για την ανάδειξη ποιοτικών και περιβαλλοντικά υπεύθυνων ακτών και μαρινών στην Ελλάδα. Η ανάδειξη γίνεται βάσει αυστηρών διεθνών κριτηρίων, τα οποία περιλαμβάνουν ποιότητα νερού, περιβαλλοντική διαχείριση, ασφάλεια και ενημέρωση του κοινού. Η πλατφόρμα παρέχει κατάλογο βραβευμένων τοποθεσιών με αναλυτικές πληροφορίες, όπως τοποθεσία, υπηρεσίες, προσβασιμότητα και εκπαιδευτικά προγράμματα περιβαλλοντικής ευαισθητοποίησης.
                    `,
    },
    {
        title: "Σύνδεσμος Προστασίας και Ανάπτυξης Υμηττού (ΣΠΑΥ)",
        url: "https://spay.gr",
        category: "ΠεριβαλλοΜη Κυβερνητικοί Οργανισμοί",
        imgUrl: "https://spay.gr/wp-content/uploads/2021/06/favicon.png",
        description:`
                        Ο Σύνδεσμος Προστασίας και Ανάπτυξης Υμηττού (ΣΠΑΥ) ενώνει δώδεκα δήμους της Αττικής για την προστασία του Υμηττού. Διοργανώνει το ετήσιο ΣΠΑΥ Forum, εστιάζοντας σε θέματα όπως η τεχνητή νοημοσύνη και οι ανθεκτικές πόλεις. Προωθεί περιβαλλοντικές δράσεις και υποστηρίζει τον εθελοντισμό. Παρέχει πληροφορίες για επιχορηγήσεις από το Πράσινο Ταμείο και διαχείριση δεδομένων με διαφάνεια.
                    `,
    },
    {
        title: "Περιβαλλοντικός Σύνδεσμος Δήμων Αθήνας-Πειραιά (ΠΕΣΥΔΑΠ)",
        url: "https://pesydap.gr/",
        category: "ΠεριβαλλοΜη Κυβερνητικοί Οργανισμοί",
        imgUrl: "https://t1.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://pesydap.gr/&size=128",
        description:`
                        Ο Περιβαλλοντικός Σύνδεσμος Δήμων Αθήνας-Πειραιά (ΠΕΣΥΔΑΠ) είναι διαδημοτικός φορέας με 22 δήμους-μέλη. Έχει ως στόχο τη μελέτη των  προβλημάτων των περιοχών που καλύπτουν οι Δήμοι μέλη  του, την παροχή συμβουλών σε θέματα περιβάλλοντος και την εκπόνηση μελετών, έργων και ερευνητικών προγραμμάτων σχετικών με το περιβάλλον.
                    `,
    },
    {
        title: "Διαδημοτικό Κέντρο Περίθαλψης Αδέσποτων Ζώων (ΔΙΚΕΠΑΖ)",
        url: "https://dikepaz.gr/",
        category: "ΠεριβαλλοΜη Κυβερνητικοί Οργανισμοί",
        imgUrl: "https://dikepaz.gr/favicon.ico",
        description:`
                        Το Διαδημοτικό Κέντρο Περίθαλψης Αδέσποτων Ζώων (ΔΙΚΕΠΑΖ), λειτουργεί στο Σχιστό Περάματος. Περισυλλέγει αδέσποτα ζώα, στα οποία παρέχει κτηνιατρικό έλεγχο, στείρωση και εμβολιασμούς. Προωθεί την υιοθεσία ζώων μέσω της ιστοσελίδας του και προσφέρει δωρεάν ηλεκτρονική σήμανση (microchip) και εμβολιασμούς σε εκδηλώσεις.
                    `,
    },

    //Συμμετοχή

    {
        title: "Υπουργείο Εσωτερικών",
        url: "https://www.ypes.gr/",
        category: "ΣυμμετοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://t1.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.ypes.gr/&size=128",
        description:`
                        Το Υπουργείο Εσωτερικών διαχειρίζεται θέματα διοίκησης, αποκέντρωσης και τοπικής αυτοδιοίκησης στην Ελλάδα. Επιβλέπει εκλογικές διαδικασίες και τη λειτουργία δήμων και περιφερειών. Παρέχει ψηφιακές υπηρεσίες μέσω του Gov.gr, όπως έκδοση πιστοποιητικών γέννησης και ταυτοτήτων. Υποστηρίζει την κοινωνική ένταξη και την ιθαγένεια μέσω διαδικασιών πολιτογράφησης.
                    `,
    },
    {
        title: "Μάθε που Ψηφίζεις",
        url: "https://mpp.ypes.gov.gr/",
        category: "ΣυμμετοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://mpp.ypes.gov.gr/&size=128",
        description:`
                        Υπηρεσία του Υπουργείου Εσωτερικών όπου οι πολίτες μπορούν να μάθουν πού ψηφίζουν.
                    `,
    },
    {
        title: "Αξιολόγηση Δημόσιας Διοίκησης",
        url: "https://axiologisi.ypes.gov.gr/home/",
        category: "ΣυμμετοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://t1.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://axiologisi.ypes.gov.gr/home&size=128",
        description:`
                        Η πλατφόρμα του Υπουργείου Εσωτερικών δίνει τη δυνατότητα στους πολίτες να αξιολογούν τις δημόσιες υπηρεσίες. Η συμμετοχή είναι εθελοντική, γίνεται με κωδικούς TaxisNet, μέσω σύντομου ερωτηματολογίου (διάρκεια περίπου 7 λεπτά). Στόχος είναι η βελτίωση της εξυπηρέτησης και η ενίσχυση της διαφάνειας.
                    `,
    },
    {
        title: "Δήλωση Καθαρισμού Οικοπέδου",
        url: "https://www.gov.gr/ipiresies/polites-kai-kathemerinoteta/periballon-kai-poioteta-zoes/delose-katharismou-oikopedou",
        category: "ΣυμμετοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://www.gov.gr/favicon.ico",
        description:`
                        Η υπηρεσία «Δήλωση καθαρισμού οικοπέδου» επιτρέπει την υποβολή υπεύθυνης δήλωσης στο Μητρώο Τήρησης Μέτρων Προληπτικής Πυροπροστασίας. Απευθύνεται σε ιδιοκτήτες, επικαρπωτές, μισθωτές και υπομισθωτές οικοπεδικών και ακάλυπτων χώρων που βρίσκονται σε συγκεκριμένες κατηγορίες περιοχών. Για την υποβολή απαιτούνται κωδικοί πρόσβασης Taxisnet και ο Κωδικός Αριθμός Εθνικού Κτηματολογίου (ΚΑΕΚ) του οικοπέδου ή εναλλακτικά οι συντεταγμένες του οικοπέδου σε περιοχές όπου το Κτηματολόγιο δεν είναι ακόμη σε λειτουργία.
                    `,
    },
    {
        title: "Διαύγεια",
        url: "https://diavgeia.gov.gr/",
        category: "ΣυμμετοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://diavgeia.gov.gr/&size=128",
        description:`
                        Η Διαύγεια είναι η επίσημη κυβερνητική πύλη για την ανάρτηση δημόσιων πράξεων. Το σύστημα αποτελεί βασικό εργαλείο διαφάνειας του δημόσιου τομέα, επιτρέποντας στους πολίτες την πρόσβαση σε δημόσιες πράξεις και αποφάσεις.
                    `,
    },

    {
        title: "Φρόντισε να ακούγεσαι - Ευρωπαϊκό Κοινοβούλιο",
        url: "https://www.europarl.europa.eu/at-your-service/el/be-heard/",
        category: "ΣυμμετοΕυρωπαϊκοί Οργανισμοί",
        imgUrl: "https://www.europarl.europa.eu/favicon.ico",
        description:`
                        Το Ευρωπαϊκό Κοινοβούλιο προτρέπει τους πολίτες της ΕΕ να εκφράσουν την άποψή τους και να συμμετάσχουν στη λήψη αποφάσεων και στη διαμόρφωση ευρωπαϊκής πολιτικής.  Δίνονται πληροφορίες για τις ευρωπαϊκές εκλογές, την υποβολή καταγγελιών, την επικοινωνία με τον Ευρωπαίο Διαμεσολαβητή, την πρωτοβουλία πολιτών, και άλλες μεθόδους συμμετοχής. Διαθέσιμο και στα ελληνικά.
                    `,
    },

    {
        title: "Συνήγορος του Πολίτη",
        url: "https://www.synigoros.gr/el/",
        category: "ΣυμμετοΑνεξάρτητες αρχές",
        imgUrl: "https://www.synigoros.gr/favicon.ico",
        description:`
                        Ο Συνήγορος του Πολίτη είναι ανεξάρτητη διοικητική αρχή που έχει ως σκοπό τη διαμεσολάβηση μεταξύ των πολιτών και της Διοίκησης (δημοσίων υπηρεσιών, των Οργανισμών Τοπικής Αυτοδιοίκησης, των Νομικών Προσώπων Δημοσίου Δικαίου και ορισμένων επιχειρήσεων κοινής ωφέλειας). Η αρχή παρεμβαίνει για την προστασία των δικαιωμάτων των πολιτών, την υπεράσπισή τους έναντι διακρίσεων και την καταπολέμηση της κακοδιοίκησης. Βασική κατευθυντήρια αρχή της λειτουργίας είναι η προσήλωση στη λογική του θετικού αθροίσματος, δηλαδή η διερεύνηση και ανάδειξη λύσεων από τις οποίες βγαίνουν κερδισμένοι τόσο οι πολίτες όσο και η διοίκηση.
                    `,
    },
    {
        title: "Συνήγορος του Παιδιού",
        url: "https://www.synigoros.gr/paidi/",
        category: "ΣυμμετοΑνεξάρτητες αρχές",
        imgUrl: "https://www.synigoros.gr/favicon.ico",
        description:`
                        Ο Συνήγορος του Παιδιού είναι ανεξάρτητη αρχή που προάγει και προστατεύει τα δικαιώματα των παιδιών στην Ελλάδα. Παρέχει δωρεάν και εμπιστευτική υποστήριξη σε παιδιά και εφήβους που αντιμετωπίζουν παραβιάσεις δικαιωμάτων, όπως κακοποίηση, σχολική διαρροή ή αποκλεισμό από κοινωνικές υπηρεσίες. Μέσω της ιστοσελίδας του, προσφέρει εργαλεία αναφοράς, ενημερωτικά υλικά και πρόσβαση σε δράσεις υπεράσπισης.
                    `,
    },
    {
        title: "Ευρωπαίος Διαμεσολαβητής",
        url: "https://europa.eu/!PVhW7t/",
        category: "ΣυμμετοΑνεξάρτητες αρχές",
        imgUrl: "https://europa.eu/favicon.ico",
        description:`
                        Ο Ευρωπαίος Διαμεσολαβητής είναι ένας ανεξάρτητος και αμερόληπτος θεσμός στον οποίο λογοδοτεί η διοίκηση της Ευρωπαϊκής Ένωσης. Διερευνά αναφορές για περιπτώσεις κακοδιοίκησης εκ μέρους των θεσμικών και λοιπών οργάνων και οργανισμών της ΕΕ. Όλοι οι πολίτες ή κάτοικοι της ΕΕ, οι επιχειρήσεις, οι ενώσεις ή άλλοι οργανισμοί που έχουν την καταστατική τους έδρα στην ΕΕ μπορούν να υποβάλουν αναφορά ακόμα και αν το κρούσμα κακοδιοίκησης δεν τους θίγει προσωπικά.
                    `,
    },

    //Βασικές Ψηφιακές Δεξιότητες

    {
        title: "Υπουργείο Ψηφιακής Διακυβέρνησης",
        url: "https://mindigital.gr/",
        category: "ΔεξιοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.mindigital.gr/&size=128",
        description:`
                        Το Υπουργείο Ψηφιακής Διακυβέρνησης αρμόδιο για την προώθηση του ψηφιακού μετασχηματισμού. Διαχειρίζεται το Gov.gr, προσφέροντας διάφορες ψηφιακές υπηρεσίες.
                    `,
    },
    {
        title: "Εθνική Ακαδημία Ψηφιακών Δεξιοτήτων",
        url: "https://nationaldigitalacademy.gov.gr/",
        category: "ΔεξιοΚυβερνητικοί Οργανισμοί",
        imgUrl: "https://nationaldigitalacademy.gov.gr/favicon.ico",
        description:`
                        Η Εθνική Ακαδημία Ψηφιακών Δεξιοτήτων είναι πρωτοβουλία του Υπουργείου Ψηφιακής Διακυβέρνησης σε συνεργασία με το GRNET, με στόχο την ενίσχυση των ψηφιακών δεξιοτήτων όλων των πολιτών, συμπεριλαμβανομένων ηλικιωμένων, γυναικών και ΑμεΑ. Προσφέρει δωρεάν εξ αποστάσεως μαθήματα σε θεματικές όπως: επικοινωνία, χρήση εργαλείων διαδικτύου, ψηφιακή επιχειρηματικότητα και τεχνολογίες αιχμής. Διαθέτει εργαλείο αυτοαξιολόγησης για να εντοπίζουν οι χρήστες το επίπεδό τους και να ακολουθούν εξατομικευμένες διαδρομές μάθησης. Υλοποιεί εθνικά και ευρωπαϊκά έργα, όπως πρωτοβουλίες WomenInTech και δράσεις για την τρίτη ηλικία, ενισχύοντας τη συμμετοχή και ισότητα στον ψηφιακό κόσμο.
                    `,
    },

    {
        title: "Επαλήθευση ειδήσεων/δηλώσεων",
        url: "https://check4facts.gr/",
        category: "ΔεξιοΑνεξάρτητοι Οργανισμοί",
        imgUrl: "https://check4facts.gr/favicon.ico",
        description:`
                        Ανεξάρτητος οργανισμός ο οποίος ελέγχει την αξιοπιστία δηλώσεων και ειδήσεων, με έμφαση σε υγεία, κλιματική κρίση, μεταναστευτικό και εγκληματικότητα. Συνδυάζει μηχανική μάθηση με ερευνητική δημοσιογραφία για επαλήθευση με διαφάνεια. Συνεργάζεται με ειδικούς επιστήμονες και αξιόπιστους φορείς με στόχο την προώθηση διαλόγου και την καταπολέμηση της παραπληροφόρησης.
                    `,
    },

    {
        title: "Microsoft Word - Βασικές Συντομεύσεις (μέσα στην παρένθεση για χρήστες Mac)",
        url: "https://support.microsoft.com/el-gr/office/%CF%83%CF%85%CE%BD%CF%84%CE%BF%CE%BC%CE%B5%CF%8D%CF%83%CE%B5%CE%B9%CF%82-%CF%80%CE%BB%CE%B7%CE%BA%CF%84%CF%81%CE%BF%CE%BB%CE%BF%CE%B3%CE%AF%CE%BF%CF%85-%CF%83%CF%84%CE%BF-word-95ef89dd-7142-4b50-afb2-f762f663ceb2",
        category: "ΔεξιοΣυντομεύσεις",
        imgUrl: "https://support.microsoft.com/favicon.ico",
        description:`
                        1.	Ctrl + N (⌘ + N): Δημιουργία νέου εγγράφου.
                        2.	Ctrl + O (⌘ + O): Άνοιγμα υπάρχοντος εγγράφου.
                        3.	Ctrl + S (⌘ + S): Αποθήκευση εγγράφου.
                        4.	F12 (⌘ + Shift + S): Αποθήκευση ως (νέο όνομα ή φάκελος).
                        5.	Ctrl + W (⌘ + W): Κλείσιμο τρέχοντος εγγράφου.
                        6.	Ctrl + P (⌘ + P): Εκτύπωση εγγράφου.
                        7.	Alt + F4 (⌘ + Q): Κλείσιμο του Word.
                    `,
    },
    {
        title: "Microsoft Word - Επεξεργασία Κειμένου (μέσα στην παρένθεση για χρήστες Mac)",
        url: "https://support.microsoft.com/el-gr/office/%CF%83%CF%85%CE%BD%CF%84%CE%BF%CE%BC%CE%B5%CF%8D%CF%83%CE%B5%CE%B9%CF%82-%CF%80%CE%BB%CE%B7%CE%BA%CF%84%CF%81%CE%BF%CE%BB%CE%BF%CE%B3%CE%AF%CE%BF%CF%85-%CF%83%CF%84%CE%BF-word-95ef89dd-7142-4b50-afb2-f762f663ceb2",
        category: "ΔεξιοΣυντομεύσεις",
        imgUrl: "https://support.microsoft.com/favicon.ico",
        description: `
                        1. Ctrl + Z (⌘ + Z): Αναίρεση τελευταίας ενέργειας.
                        2. Ctrl + Y (⌘ + Y): Επανάληψη τελευταίας ενέργειας.
                        3. Ctrl + X (⌘ + X): Αποκοπή επιλεγμένου κειμένου.
                        4. Ctrl + C (⌘ + C): Αντιγραφή επιλεγμένου κειμένου.
                        5. Ctrl + V (⌘ + V): Επικόλληση κειμένου.
                        6. Ctrl + A (⌘ + A): Επιλογή όλου του κειμένου.
                        7. Ctrl + F (⌘ + F): Αναζήτηση κειμένου.
                        8. Ctrl + H (⌘ + H): Αντικατάσταση κειμένου.
                        9. Ctrl + D (⌘ + D): Άνοιγμα παραθύρου γραμματοσειράς.
                    `,
    },
    {
        title: "Microsoft Word - Μορφοποίηση Κειμένου (μέσα στην παρένθεση για χρήστες Mac)",
        url: "https://support.microsoft.com/el-gr/office/%CF%83%CF%85%CE%BD%CF%84%CE%BF%CE%BC%CE%B5%CF%8D%CF%83%CE%B5%CE%B9%CF%82-%CF%80%CE%BB%CE%B7%CE%BA%CF%84%CF%81%CE%BF%CE%BB%CE%BF%CE%B3%CE%AF%CE%BF%CF%85-%CF%83%CF%84%CE%BF-word-95ef89dd-7142-4b50-afb2-f762f663ceb2",
        category: "ΔεξιοΣυντομεύσεις",
        imgUrl: "https://support.microsoft.com/favicon.ico",
        description: `
                        1. Ctrl + B (⌘ + B): Ενεργοποίηση/απενεργοποίηση έντονης γραφής.
                        2. Ctrl + I (⌘ + I): Ενεργοποίηση/απενεργοποίηση πλάγιας γραφής.
                        3. Ctrl + U (⌘ + U): Ενεργοποίηση/απενεργοποίηση υπογράμμισης.
                        4. Ctrl + Shift + > (⌘ + Shift + >): Αύξηση μεγέθους γραμματοσειράς.
                        5. Ctrl + Shift + < (⌘ + Shift + <): Μείωση μεγέθους γραμματοσειράς.
                        6. Ctrl + E (⌘ + E): Κεντρική στοίχιση.
                        7. Ctrl + L (⌘ + L): Αριστερή στοίχιση.
                        8. Ctrl + R (⌘ + R): Δεξιά στοίχιση.
                        9. Ctrl + J (⌘ + J): Πλήρης στοίχιση.
                    `,
    },
    {
        title: "Microsoft Word - Πλοήγηση στο Έγγραφο (μέσα στην παρένθεση για χρήστες Mac)",
        url: "https://support.microsoft.com/el-gr/office/%CF%83%CF%85%CE%BD%CF%84%CE%BF%CE%BC%CE%B5%CF%8D%CF%83%CE%B5%CE%B9%CF%82-%CF%80%CE%BB%CE%B7%CE%BA%CF%84%CF%81%CE%BF%CE%BB%CE%BF%CE%B3%CE%AF%CE%BF%CF%85-%CF%83%CF%84%CE%BF-word-95ef89dd-7142-4b50-afb2-f762f663ceb2",
        category: "ΔεξιοΣυντομεύσεις",
        imgUrl: "https://support.microsoft.com/favicon.ico",
        description: `
                        1. Ctrl + Home (⌘ + Home): Μετάβαση στην αρχή του εγγράφου.
                        2. Ctrl + End (⌘ + End): Μετάβαση στο τέλος του εγγράφου.
                        3. Ctrl + Left Arrow (⌘ + Left Arrow): Μετάβαση μία λέξη αριστερά.
                        4. Ctrl + Right Arrow (⌘ + Right Arrow): Μετάβαση μία λέξη δεξιά.
                        5. Ctrl + Up Arrow (⌘ + Up Arrow): Μετάβαση μία παράγραφο πάνω.
                        6. Ctrl + Down Arrow (⌘ + Down Arrow): Μετάβαση μία παράγραφο κάτω.
                        7. F5: Άνοιγμα του παραθύρου "Μετάβαση σε" (σελίδα, ενότητα, κ.λπ.).
                        8. Shift + F5: Κύκλος στις τελευταίες τρεις θέσεις του κέρσορα.
                    `,
    },
    {
        title: "Microsoft Excel - Εργασία με Πίνακες",
        url: "https://support.microsoft.com/el-gr/office/%CF%83%CF%85%CE%BD%CF%84%CE%BF%CE%BC%CE%B5%CF%8D%CF%83%CE%B5%CE%B9%CF%82-%CF%80%CE%BB%CE%B7%CE%BA%CF%84%CF%81%CE%BF%CE%BB%CE%BF%CE%B3%CE%AF%CE%BF%CF%85-%CF%83%CF%84%CE%BF-excel-1798d9d5-842a-42b8-9c99-9b7213f0040f",
        category: "ΔεξιοΣυντομεύσεις",
        imgUrl: "https://support.microsoft.com/favicon.ico",
        description: `
                        1. Tab: Μετάβαση στο επόμενο κελί πίνακα.
                        2. Shift + Tab: Μετάβαση στο προηγούμενο κελί πίνακα.
                        3. Ctrl + T: Εισαγωγή πίνακα (σε ορισμένες εκδόσεις).
                        4. Ctrl + Shift + M: Συγχώνευση κελιών.
                        5. Ctrl + Shift + S: Διαχωρισμός κελιών.
                    `,
    },
    {
        title: "Microsoft - Εργασία με πολλαπλά παράθυρα",
        url: "https://support.microsoft.com/el-gr/windows/%CF%83%CF%85%CE%BD%CF%84%CE%BF%CE%BC%CE%B5%CF%8D%CF%83%CE%B5%CE%B9%CF%82-%CF%80%CE%BB%CE%B7%CE%BA%CF%84%CF%81%CE%BF%CE%BB%CE%BF%CE%B3%CE%AF%CE%BF%CF%85-%CF%83%CF%84%CE%B1-windows-dcc61a57-8ff0-cffe-9796-cb9706c75eec",
        category: "ΔεξιοΣυντομεύσεις",
        imgUrl: "https://support.microsoft.com/favicon.ico",
        description: `
                        1. Alt + Tab: Εναλλαγή μεταξύ όλων των ανοιχτών παραθύρων και εφαρμογών.
	                    2. Ctrl + Tab: Εναλλαγή μεταξύ ανοιχτών εγγράφων ή καρτελών εντός του Word (σε ορισμένες εκδόσεις ή με πολλαπλά έγγραφα).
                        3. Ctrl + F6 ή Ctrl + Shift + F6: Εναλλαγή μεταξύ ανοιχτών παραθύρων του Word (ειδικά για πολλαπλά έγγραφα).
                    `,
    },
    {
        title: "Apple - Εργασία με πολλαπλά παράθυρα",
        url: "https://support.apple.com/el-gr/102650",
        category: "ΔεξιοΣυντομεύσεις",
        imgUrl: "https://support.apple.com/favicon.ico",
        description: `
                        1. ⌘ + Tab: Εναλλαγή μεταξύ ανοιχτών εφαρμογών.
                        2. ⌘ + Tilde (~): Εναλλαγή μεταξύ παραθύρων της ίδιας εφαρμογής (π.χ. έγγραφα Word).
                    `,
    },

    //Σχετικά

    {
        title: "Σχετικά",
        url: "/",
        category: "Σχετικά",
        imgUrl: "/SafeDigitalWaters_horizontal_01.png",
        description:`
                        Διαδικτυακή πύλη για πληροφορίες σε ζωτικούς τομείς.
                    `,
    },
];